<div class="overlay" *ngIf="ShowConfirmationQuestion || ShowOrderCancelation || ShowOrderCopy || ShowEditContainer || ShowGeneratePOConfirmation || ShowChangePartnerConfirmation;"></div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowOrderCopy">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowOrderCopy = false; CurrentOrder = null;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'CopyOfferTitle' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'CopyOfferDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowOrderCopy = false; CurrentOrder = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowOrderCopy = false;CopyOrder(CurrentOrder);">{{ 'AcceptAndContinueCopy' | translate }}</button>
    </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowOrderCancelation">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowOrderCancelation = false; CurrentOrder = null;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'CancelQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'CancelQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowOrderCancelation = false; CurrentOrder = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowOrderCancelation = false;CancelOrder(CurrentOrder);">{{ 'YesCancel' | translate }}</button>
    </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowConfirmationQuestion">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowConfirmationQuestion = false; CurrentOrder = null;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'ConfirmOrder' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{ 'ConfirmOrderDescription' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" mat-raised-button color="accent" class="InfoQuestionButton" (click)="ConfirmOrder(CurrentOrder); ShowConfirmationQuestion = false; CurrentOrder = null;">{{ 'ConfirmOrder' | translate }}</button>
    <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowConfirmationQuestion = false;">{{ 'YesCancel' | translate }}</button>
  </div>
</div>

<!-- Generate Purchase Order (PO) Confirmation Popup -->
<div class="ConvertToOrderConfirmationOverlay" *ngIf="ShowGeneratePOConfirmation" (click)="ShowGeneratePOConfirmation = false;"></div>
<div class="ConvertToOrderConfirmationPopup animated fadeInDown" *ngIf="ShowGeneratePOConfirmation">
  <div class="ConvertPopupHeader">
    <div class="ConvertPopupIconWrapper" style="background: #f60;">
      <i class="material-icons">shopping_cart</i>
    </div>
    <div class="ConvertPopupHeaderText">
      <span class="ConvertPopupTitle">{{ 'GeneratePO' | translate }}</span>
      <span class="ConvertPopupRef">{{ CurrentOrder?.ReferenceNumber }}</span>
    </div>
    <i class="material-icons ConvertPopupClose" (click)="ShowGeneratePOConfirmation = false;">close</i>
  </div>
  <div class="ConvertPopupBody">
    <p class="ConvertPopupMessage">{{ 'GeneratePOConfirmation' | translate }}</p>
  </div>
  <div class="ConvertPopupFooter">
    <div class="GridCommandButton" [class.disabled]="this.parent.loading" (click)="ShowGeneratePOConfirmation = false;">
      <i class="material-icons">close</i>
      <span>{{ 'No' | translate }}</span>
    </div>
    <div class="GridCommandButton GridCommandButtonOrange" [class.disabled]="this.parent.loading" (click)="ShowGeneratePOConfirmation = false;">
      <i class="material-icons" *ngIf="!this.parent.loading">check</i>
      <span *ngIf="!this.parent.loading">{{ 'Yes' | translate }}</span>
      <mat-spinner *ngIf="this.parent.loading" diameter="18"></mat-spinner>
    </div>
  </div>
</div>

<!-- Change Sell Currency Popup -->
<div class="ConvertToOrderConfirmationOverlay" *ngIf="ShowChangeSellCurrencyPopup" (click)="ShowChangeSellCurrencyPopup = false;"></div>
<div class="ConvertToOrderConfirmationPopup animated fadeInDown" *ngIf="ShowChangeSellCurrencyPopup" style="width: 420px; left: calc(50% - 210px); top: 25%;">
  <div class="ConvertPopupHeader">
    <div class="ConvertPopupIconWrapper">
      <i class="material-icons">currency_exchange</i>
    </div>
    <div class="ConvertPopupHeaderText">
      <span class="ConvertPopupTitle">{{ 'ChangeSellCurrency' | translate }}</span>
      <span class="ConvertPopupRef">{{ CurrentOrder?.ReferenceNumber }}</span>
    </div>
    <i class="material-icons ConvertPopupClose" (click)="ShowChangeSellCurrencyPopup = false;">close</i>
  </div>
  <div class="ConvertPopupBody" style="padding: 20px;">
    <div class="ConvertPopupMessage important" style="margin-bottom: 16px;">
      <i class="material-icons" style="color: #f60; font-size: 20px; flex-shrink: 0;">warning</i>
      <span>{{ 'ChangeSellCurrencyExplanation' | translate }}</span>
    </div>
    <div class="CurrencySearchContainer">
      <div class="CurrencySearchBar" (click)="showSellCurrencyResults = !showSellCurrencyResults">
        <span class="currency-label">{{'Currency' | translate}}</span>
        <input
          type="text"
          class="CurrencySearchInput"
          [value]="selectedSellCurrency ? selectedSellCurrency.Symbol + ' - ' + selectedSellCurrency.Name : ''"
          readonly
        />
        <i class="material-icons dropdown-icon">arrow_drop_down</i>
      </div>
      <div class="CurrencySearchResults" *ngIf="showSellCurrencyResults && parent.masterData?.Currencies?.length > 0">
        <div class="CurrencySearchResult" *ngFor="let c of parent.masterData?.Currencies" (click)="selectSellCurrency(c)" [class.selected]="selectedSellCurrency?.ID === c.ID">
          <div class="CurrencyResultMain">
            <span class="CurrencyResultSymbol">{{c.Symbol}}</span>
            <span class="CurrencyResultName">{{c.Name}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="ConvertPopupFooter">
    <div class="GridCommandButton" [class.disabled]="this.parent.loading" (click)="ShowChangeSellCurrencyPopup = false;">
      <i class="material-icons">close</i>
      <span>{{ 'Cancel' | translate }}</span>
    </div>
    <div class="GridCommandButton GridCommandButtonGreen" [class.disabled]="this.parent.loading || !selectedSellCurrency" (click)="confirmChangeSellCurrency();">
      <i class="material-icons" *ngIf="!this.parent.loading">check</i>
      <span *ngIf="!this.parent.loading">{{ 'Save' | translate }}</span>
      <mat-spinner *ngIf="this.parent.loading" diameter="18"></mat-spinner>
    </div>
  </div>
</div>

<div class="EditContainer animated fadeInDown" *ngIf="this.ShowEditContainer == true;">
    <div class="EditContainerCloseButton" (click)="this.ShowEditContainer = false;">
        <i class="material-icons">close</i>
    </div>

    <!-- Modern Header -->
    <div class="EditContainerHeader">
      <div class="EditHeaderLeft">
        <div class="EditHeaderTitle">
          <i class="material-icons">description</i>
          <span>{{'PurchaseOrder' | translate}}</span>
        </div>
        <div class="EditHeaderMeta">
          <span class="EditRefNumber">{{CurrentOrder.ReferenceNumber}}</span>
          <span class="EditDebatorPO" *ngIf="CurrentOrder?.DebatorPO?.length > 0;">PO: {{CurrentOrder.DebatorPO}}</span>
        </div>
      </div>
      <div class="EditHeaderRight">
        <span class="EditStatusBadge" [ngClass]="{
          'StatusNew': CurrentOrder.POStatus?.ID == -1,
          'StatusProcessing': CurrentOrder.POStatus?.ID == 1,
          'StatusPartial': CurrentOrder.POStatus?.ID == 9,
          'StatusConfirmed': CurrentOrder.POStatus?.ID == 10 || CurrentOrder.POStatus?.ID == 12,
          'StatusCanceled': CurrentOrder.POStatus?.ID == 11
        }">
          {{CurrentOrder.POStatus?.Name}}
        </span>
      </div>
    </div>

    <div class="EditContainerBody">

      <!-- ✅ Partner & Currency Management Section -->
      <div class="PartnerCurrencyManagementSection">
        <!-- Partner Search Container -->
        <div class="PartnerSearchContainer">
          <!-- Transparent Overlay (closes partner results when clicking outside) -->
          <div class="EditContainerOverlayTransparent" *ngIf="showEditContainerPartnerResults" (click)="showEditContainerPartnerResults = false"></div>

          <div class="PartnerSearchBar">
            <i class="material-icons search-icon" *ngIf="!editContainerPartnerSearchTerm || editContainerPartnerSearchTerm.length === 0">search</i>
            <i class="material-icons clear-icon" *ngIf="editContainerPartnerSearchTerm?.length > 0" (click)="clearEditContainerPartnerSearch()">close</i>
            <input type="text" class="PartnerSearchInput" [placeholder]="'SearchPartnerPlaceholder' | translate"
                   [(ngModel)]="editContainerPartnerSearchTerm" (focus)="onEditContainerPartnerSearchFocus()"
                   (ngModelChange)="editContainerPartnerSearchTermUpdate.next($event)" />
            <mat-spinner class="search-spinner" *ngIf="editContainerLoadingPartners" [diameter]="20"></mat-spinner>
          </div>

          <div class="PartnerSearchResults" *ngIf="showEditContainerPartnerResults && editContainerSearchedPartners?.length > 0">
            <div class="PartnerSearchResult" *ngFor="let p of editContainerSearchedPartners" (click)="selectEditContainerPartner(p)">
              <div class="PartnerResultMain">
                <span class="PartnerCountryBadge" *ngIf="p.BillingAddress?.Country?.ShortName">[{{p.BillingAddress.Country.ShortName}}]</span>
                <span class="PartnerName">{{p.Name}}</span>
                <span class="PartnerVAT" *ngIf="p.BillingAddress?.VATNumber">{{p.BillingAddress.VATNumber}}</span>
              </div>
            </div>
          </div>

          <div class="SelectedPartnerDisplay" *ngIf="CurrentOrder?.Cart?.Partner" (click)="openPartnerInNewTab()" style="cursor: pointer;" matTooltip="{{ 'OpenPartnerDetails' | translate }}" matTooltipClass='neutral-tool-tip-management'>
            <div class="SelectedPartnerInfo">
              <i class="material-icons SelectedPartnerCheckmark">check_circle</i>
              <span class="SelectedPartnerName">{{CurrentOrder.Cart.Partner.Name}}</span>
              <span class="SelectedPartnerVAT" *ngIf="CurrentOrder.Cart.Partner.BillingAddress?.VATNumber">{{CurrentOrder.Cart.Partner.BillingAddress.VATNumber}}</span>
            </div>
          </div>
        </div>

        <!-- Currency Search Container -->
        <div class="CurrencySearchContainer">
          <!-- Transparent Overlay (closes currency results when clicking outside) -->
          <div class="EditContainerOverlayTransparent" *ngIf="showEditContainerCurrencyResults" (click)="showEditContainerCurrencyResults = false"></div>

          <div class="CurrencySearchBar" (click)="toggleEditContainerCurrencyDropdown()">
            <i class="material-icons">attach_money</i>
            <span class="currency-label">{{CurrentOrder?.Cart?.Currency?.Name || 'Select Currency'}}</span>
            <i class="material-icons">expand_more</i>
          </div>

          <div class="CurrencySearchResults" *ngIf="showEditContainerCurrencyResults && MasterData?.Currencies?.length > 0">
            <div class="CurrencySearchResult" *ngFor="let c of MasterData.Currencies" (click)="selectEditContainerCurrency(c)">
              <span class="CurrencyName">{{c.Name}}</span>
              <span class="CurrencySymbol">{{c.Symbol}}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- ✅ Totals Section (like accept-offer page) -->
      <div class="totals-section" *ngIf="CurrentOrder?.Cart?.Total">
        <!-- Subtotal (from OriginalTotal - before any project discount) -->
        <div class="total-row subtotal-row">
          <span class="total-label">{{'Subtotal' | translate}}:</span>
          <span class="total-value subtotal-value">{{ CurrentOrder.Cart.OriginalTotal?.TotalQtyPriceNOVAT | number:'1.2-2' }} {{ CurrentOrder.Cart?.Currency?.Symbol }}</span>
        </div>

        <!-- Project Discount Row (only shown if discount exists) -->
        <div class="total-row discount-row" *ngIf="CurrentOrder.Cart.Total?.Discount?.Value > 0">
          <span class="total-label discount-label">
            {{'ProjectDiscount' | translate}}
            (<ng-container *ngIf="CurrentOrder.Cart.Total.Discount.Type?.ID === 1">{{ CurrentOrder.Cart.Total.Discount.Value | number:'1.2-2' }}%</ng-container><ng-container *ngIf="CurrentOrder.Cart.Total.Discount.Type?.ID === 2">{{ CurrentOrder.Cart.Total.Discount.Value | number:'1.2-2' }} {{ CurrentOrder.Cart?.Currency?.Symbol }}</ng-container>):
          </span>
          <span class="total-value discount-value">- {{ getProjectDiscountAmount() }} {{ CurrentOrder.Cart?.Currency?.Symbol }}</span>
        </div>

        <!-- Subtotal After Discount (only shown if discount exists) -->
        <div class="total-row subtotal-after-discount-row" *ngIf="CurrentOrder.Cart.Total?.Discount?.Value > 0">
          <span class="total-label">{{'SubtotalAfterDiscount' | translate}}:</span>
          <span class="total-value">{{ CurrentOrder.Cart.Total.TotalQtyPriceNOVAT | number:'1.2-2' }} {{ CurrentOrder.Cart?.Currency?.Symbol }}</span>
        </div>

        <!-- Shipping + Purchase Total Row (side by side) -->
        <div class="shipping-purchase-row">
          <div class="total-row shipping-row">
            <span class="total-label">{{'ShippingCost' | translate}}:</span>
            <span class="total-value shipping-value">{{ CurrentOrder.Cart.ShippingCost?.UIUnitPrice != null ? (CurrentOrder.Cart.ShippingCost.UIUnitPrice | number:'1.2-2') : '--,--' }} {{ CurrentOrder.Cart?.Currency?.Symbol }}</span>
          </div>
          <div class="total-row purchase-total-row" *ngIf="CurrentOrder.Cart.PurchaseTotal?.TotalQtyPriceNOVAT > 0">
            <span class="total-label">{{'PurchaseTotalNoVAT' | translate}}:</span>
            <span class="total-value">{{ CurrentOrder.Cart.PurchaseTotal.TotalQtyPriceNOVAT | number:'1.2-2' }} {{ CurrentOrder.Cart.PurchaseTotal?.Currency?.Symbol || CurrentOrder.Cart?.Currency?.Symbol }}</span>
          </div>
        </div>

        <!-- Final Total (Subtotal + Shipping) -->
        <div class="total-row absolute-total-row">
          <span class="total-label">{{'GrandTotal' | translate}}:</span>
          <span class="total-value absolute-total-value">{{ getAbsoluteTotal() }} {{ CurrentOrder.Cart?.Currency?.Symbol }}</span>
        </div>
      </div>

      <!-- ✅ Discount Controls (kept for editing) -->
      <div class="OrderTotalRow">
        <span class="OrderTotalLabel">{{'Discount' | translate}}:</span>
        <div class="DiscountControls">
          <!-- Discount Type Dropdown -->
          <div class="CustomDropdownContainer DiscountDropdownContainer">
            <div class="DropdownOverlayTransparent" *ngIf="showDiscountTypeDropdown" (click)="showDiscountTypeDropdown = false"></div>
            <div class="CustomDropdownBar" (click)="showDiscountTypeDropdown = !showDiscountTypeDropdown">
              <i class="material-icons dropdown-icon-left">percent</i>
              <input type="text" class="CustomDropdownInput" readonly
                     [class.placeholder]="!this.CurrentOrder?.Cart?.Total?.Discount?.Type"
                     [value]="this.CurrentOrder?.Cart?.Total?.Discount?.Type?.Name || 'Select...'" />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>
            <div class="CustomDropdownResults" *ngIf="showDiscountTypeDropdown">
              <div class="CustomDropdownResult" *ngFor="let type of parent.masterData?.DiscountTypes"
                   (click)="selectDiscountType(type)">
                <div class="CustomDropdownResultMain">
                  <span class="CustomDropdownResultText">{{type.Name}}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- Discount Value Input -->
          <div class="CustomDropdownBar CustomDropdownBarInput DiscountValueContainer">
            <input type="text" class="CustomDropdownInput DiscountValueInput"
                   [(ngModel)]="this.CurrentOrder.Cart.Total.Discount.Value"
                   (keypress)="validateDiscountInput($event)"
                   placeholder="0" />
          </div>
          <!-- Apply Discount Button -->
          <button class="GridCommandButton GridCommandButtonBlue" (click)="ApplyOrderDiscount()" [disabled]="!this.CurrentOrder?.Cart?.Total?.Discount?.Type || !this.CurrentOrder?.Cart?.Total?.Discount?.Value">
            <i class="material-icons">check</i>
          </button>
          <!-- Clear Discount Button -->
          <button class="GridCommandButton GridCommandButtonRed" (click)="ClearOrderDiscount()" [disabled]="!this.CurrentOrder?.Cart?.Total?.Discount?.Type && !this.CurrentOrder?.Cart?.Total?.Discount?.Value">
            <i class="material-icons">close</i>
          </button>
        </div>
      </div>

      <!-- Modern Collapsible Section -->
      <div class="EditSection">
        <div class="EditSectionHeader" (click)="this.ShowOrderGeneralInformation = !this.ShowOrderGeneralInformation">
          <div class="EditSectionHeaderLeft">
            <i class="material-icons">info</i>
            <span>{{'GeneralInfomration' | translate}}</span>
          </div>
          <i class="material-icons EditSectionToggle">{{this.ShowOrderGeneralInformation ? 'expand_less' : 'expand_more'}}</i>
        </div>

        <div class="EditSectionBody" *ngIf="this.ShowOrderGeneralInformation == true;">
          <div class="EditFieldsGrid EditFieldsGridCustom">
            <!-- Request Number -->
            <div class="CustomDropdownContainer EditField">
              <div class="CustomDropdownBar CustomDropdownBarInput disabled">
                <i class="material-icons dropdown-icon-left">tag</i>
                <span class="dropdown-label">{{'OurReferenceNumber' | translate}}</span>
                <input type="text" class="CustomDropdownInput" readonly [value]="this.CurrentOrder.ReferenceNumber" />
              </div>
            </div>

            <!-- Debator PO -->
            <div class="CustomDropdownContainer EditField">
              <div class="CustomDropdownBar CustomDropdownBarInput" style="border: 2px solid #f60;">
                <i class="material-icons dropdown-icon-left">receipt</i>
                <span class="dropdown-label">{{'SupplierOrderConfirmationNumber' | translate}}</span>
                <input type="text" class="CustomDropdownInput" style="letter-spacing: 2px;font-weight: 600;color: #f60;" [(ngModel)]="this.CurrentOrder.DebatorPO" />
              </div>
            </div>

            <!-- Supplier Offer Number -->
            <div class="CustomDropdownContainer EditField">
              <div class="CustomDropdownBar CustomDropdownBarInput" style="border: 2px solid #1976d2;">
                <i class="material-icons dropdown-icon-left" style="color: #1976d2;">description</i>
                <span class="dropdown-label">{{'SupplierOfferNumber' | translate}}</span>
                <input type="text" class="CustomDropdownInput" style="letter-spacing: 2px;font-weight: 600;color: #1976d2;" [(ngModel)]="this.CurrentOrder.SupplierOfferNumber" />
              </div>
            </div>

            <!-- Uploader -->
            <div class="CustomDropdownContainer EditField">
              <div class="CustomDropdownBar CustomDropdownBarInput disabled">
                <i class="material-icons dropdown-icon-left">upload</i>
                <span class="dropdown-label">{{'Uploader' | translate}}</span>
                <input type="text" class="CustomDropdownInput" readonly [value]="this.CurrentOrder.UserUploader?.UIName" />
              </div>
            </div>

            <!-- Manager -->
            <div class="CustomDropdownContainer EditField">
              <div class="CustomDropdownBar CustomDropdownBarInput disabled">
                <i class="material-icons dropdown-icon-left">person</i>
                <span class="dropdown-label">{{'Manager' | translate}}</span>
                <input type="text" class="CustomDropdownInput" readonly [value]="this.CurrentOrder.UserManager?.UIName" />
              </div>
            </div>

            <!-- Weight -->
            <div class="CustomDropdownContainer EditField">
              <div class="CustomDropdownBar CustomDropdownBarInput disabled">
                <i class="material-icons dropdown-icon-left">scale</i>
                <span class="dropdown-label">{{'Weight' | translate}}</span>
                <input type="text" class="CustomDropdownInput" readonly
                       [value]="this.CurrentOrder.Cart?.Weight ? (this.CurrentOrder.Cart.Weight + ' ' + (this.CurrentOrder.Cart?.WeightMeasurementType?.Name || '')) : '--'" />
              </div>
            </div>

            <!-- Currency -->
            <div class="CustomDropdownContainer EditField">
              <div class="CustomDropdownBar CustomDropdownBarInput disabled">
                <i class="material-icons dropdown-icon-left">currency_exchange</i>
                <span class="dropdown-label">{{'Currency' | translate}}</span>
                <input type="text" class="CustomDropdownInput" readonly
                       [value]="this.CurrentOrder.Cart?.Currency?.Name && this.CurrentOrder.Cart?.Currency?.ExchangeRate ? (this.CurrentOrder.Cart.Currency.Name + ' (' + this.CurrentOrder.Cart.Currency.ExchangeRate + ')') : '--'" />
              </div>
            </div>
          </div>

          <div class="EditAgentsSection">
            <div class="EditAgentsTitle">
              <i class="material-icons">people</i>
              <span>{{'OrderContactAgents' | translate}}</span>
            </div>
            <div class="EditAgentsList">
              <div class="EditAgentItem" *ngFor="let agent of this.CurrentOrder.Cart.Partner?.PartnerAgents"
                   [ngClass]="{ 'AgentSelected': agent.IsSelected == true}"
                   (click)="agent.IsSelected = !agent.IsSelected;">
                <span class="AgentEmail">{{agent.Email}}</span>
                <i class="material-icons AgentIcon" *ngIf="agent.IsSelected == true;">check_circle</i>
                <i class="material-icons AgentIcon" *ngIf="agent.IsSelected != true;">radio_button_unchecked</i>
              </div>
            </div>
          </div>
        </div>
      </div>

        <div class="EditSection">
          <div class="EditSectionHeader" (click)="this.ShowOrderBillingInformation = !this.ShowOrderBillingInformation">
            <div class="EditSectionHeaderLeft">
              <i class="material-icons">receipt_long</i>
              <span>{{'BillingInformation' | translate}}</span>
            </div>
            <i class="material-icons EditSectionToggle">{{this.ShowOrderBillingInformation ? 'expand_less' : 'expand_more'}}</i>
          </div>

         <div class="EditSectionBody" *ngIf="this.ShowOrderBillingInformation == true;">
          <div class="EditFieldsGrid">
            <mat-form-field appearance="outline" class="EditField">
              <mat-label>{{'Name' | translate}}</mat-label>
              <input matInput disabled="true" [(ngModel)]="this.CurrentOrder.Cart.Partner.Name">
            </mat-form-field>

            <mat-form-field appearance="outline" class="EditField">
              <mat-label>{{'VAT' | translate}}</mat-label>
              <input matInput disabled="true" [(ngModel)]="this.CurrentOrder.Cart.Partner.VAT">
            </mat-form-field>

            <mat-form-field appearance="outline" class="EditField">
              <mat-label>{{'COCRegNumber' | translate}}</mat-label>
              <input matInput disabled="true" [(ngModel)]="this.CurrentOrder.Cart.Partner.COCRegNumber">
            </mat-form-field>

            <mat-form-field appearance="outline" class="EditField">
              <mat-label>{{'Country' | translate}}</mat-label>
              <input matInput disabled="true" [(ngModel)]="this.CurrentOrder.Cart.Partner.BillingAddress.Country.Name">
            </mat-form-field>

            <mat-form-field appearance="outline" class="EditField">
              <mat-label>{{'StateProvince' | translate}}</mat-label>
              <input matInput disabled="true" [(ngModel)]="this.CurrentOrder.Cart.Partner.BillingAddress.StateProvince">
            </mat-form-field>

            <mat-form-field appearance="outline" class="EditField">
              <mat-label>{{'City' | translate}}</mat-label>
              <input matInput disabled="true" [(ngModel)]="this.CurrentOrder.Cart.Partner.BillingAddress.City">
            </mat-form-field>

            <mat-form-field appearance="outline" class="EditFieldFull">
              <mat-label>{{'AddressLine' | translate}}</mat-label>
              <input matInput disabled="true" [(ngModel)]="this.CurrentOrder.Cart.Partner.BillingAddress.AddressLine">
            </mat-form-field>

            <!-- Payment Term Dropdown -->
            <div class="CustomDropdownContainer EditFieldFull">
              <div class="DropdownOverlayTransparent" *ngIf="showPaymentTermDropdown" (click)="showPaymentTermDropdown = false"></div>
              <div class="CustomDropdownBar" (click)="showPaymentTermDropdown = !showPaymentTermDropdown">
                <i class="material-icons dropdown-icon-left">payments</i>
                <span class="dropdown-label">{{'PaymentTerms' | translate}}</span>
                <input type="text" class="CustomDropdownInput" readonly
                       [class.placeholder]="!this.CurrentOrder?.Cart?.PaymentTerm"
                       [value]="this.CurrentOrder?.Cart?.PaymentTerm?.Name || 'Select...'" />
                <i class="material-icons dropdown-icon">arrow_drop_down</i>
              </div>
              <div class="CustomDropdownResults CustomDropdownResultsUpward" *ngIf="showPaymentTermDropdown">
                <div class="CustomDropdownResult" *ngFor="let term of parent.CartMasterData?.PaymentTerms"
                     (click)="selectPaymentTerm(term)">
                  <div class="CustomDropdownResultMain">
                    <i class="material-icons" [style.color]="CurrentOrder?.Cart?.PaymentTerm?.ID === term.ID ? '#10b981' : '#9ca3af'">
                      {{ CurrentOrder?.Cart?.PaymentTerm?.ID === term.ID ? 'check_circle' : 'radio_button_unchecked' }}
                    </i>
                    <span class="CustomDropdownResultText">{{term.Name}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
         </div>
        </div>

        <div class="EditSection">
          <div class="EditSectionHeader" (click)="this.ShowOrderShippingInformation = !this.ShowOrderShippingInformation">
            <div class="EditSectionHeaderLeft">
              <i class="material-icons">local_shipping</i>
              <span>{{'PickupInformation' | translate}}</span>
              <!-- Lock Shipping Settings Toggle -->
              <div class="auto-save-toggle-container" (click)="$event.stopPropagation()">
                <label class="auto-save-toggle">
                  <input type="checkbox" [(ngModel)]="this.CurrentOrder.Cart.LockShippingSettings" (change)="onLockShippingSettingsChange()">
                  <span class="toggle-slider"></span>
                </label>
                <span class="auto-save-label"><i class="material-icons" style="font-size: 14px;">{{this.CurrentOrder.Cart.LockShippingSettings ? 'lock' : 'lock_open'}}</i></span>
              </div>
            </div>
            <i class="material-icons EditSectionToggle">{{this.ShowOrderShippingInformation ? 'expand_less' : 'expand_more'}}</i>
          </div>

           <div class="EditSectionBody" *ngIf="this.ShowOrderShippingInformation == true;">
            <div class="EditFieldsGrid EditFieldsGridCustom">
              <!-- Shipping Address Dropdown -->
              <div class="CustomDropdownContainer EditFieldFull" *ngIf="this.CurrentOrder.Cart.Partner.ShippingAddresses?.length > 0">
                <div class="DropdownOverlayTransparent" *ngIf="showShippingAddressDropdown" (click)="showShippingAddressDropdown = false"></div>
                <div class="CustomDropdownBar" (click)="showShippingAddressDropdown = !showShippingAddressDropdown">
                  <i class="material-icons dropdown-icon-left">location_on</i>
                  <span class="dropdown-label">{{ 'ShippingAddresses' | translate }}</span>
                  <input type="text" class="CustomDropdownInput" readonly
                         [class.placeholder]="!this.CurrentOrder.ShippingAddress"
                         [value]="this.CurrentOrder.ShippingAddress ? (this.CurrentOrder.ShippingAddress.Country?.Name + ' ' + this.CurrentOrder.ShippingAddress.City + ' ' + this.CurrentOrder.ShippingAddress.AddressLine) : 'Select...'" />
                  <i class="material-icons dropdown-icon">arrow_drop_down</i>
                </div>
                <div class="CustomDropdownResults" *ngIf="showShippingAddressDropdown">
                  <div class="CustomDropdownResult" *ngFor="let a of this.CurrentOrder.Cart.Partner.ShippingAddresses"
                       (click)="selectShippingAddress(a)">
                    <div class="CustomDropdownResultMain">
                      <i class="material-icons">place</i>
                      <span class="CustomDropdownResultText">{{a.Country?.Name}} {{a.City}} {{a.AddressLine}}</span>
                    </div>
                  </div>
                </div>
              </div>

              <ng-container *ngIf="this.CurrentOrder.ShippingAddress">
                <!-- Country Dropdown -->
                <div class="CustomDropdownContainer EditField">
                  <div class="DropdownOverlayTransparent" *ngIf="showShippingCountryDropdown" (click)="showShippingCountryDropdown = false"></div>
                  <div class="CustomDropdownBar" (click)="showShippingCountryDropdown = !showShippingCountryDropdown">
                    <i class="material-icons dropdown-icon-left">public</i>
                    <span class="dropdown-label">{{ 'Country' | translate }}</span>
                    <input type="text" class="CustomDropdownInput" readonly
                           [class.placeholder]="!this.CurrentOrder.ShippingAddress?.Country"
                           [value]="this.CurrentOrder.ShippingAddress?.Country?.Name || 'Select...'" />
                    <i class="material-icons dropdown-icon">arrow_drop_down</i>
                  </div>
                  <div class="CustomDropdownResults" *ngIf="showShippingCountryDropdown">
                    <div class="CustomDropdownResult" *ngFor="let c of this.parent.masterData.Countries"
                         (click)="selectShippingCountry(c)">
                      <div class="CustomDropdownResultMain">
                        <span class="CustomDropdownResultText">{{c.Name}}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- State/Province -->
                <div class="CustomDropdownContainer EditField">
                  <div class="CustomDropdownBar CustomDropdownBarInput">
                    <i class="material-icons dropdown-icon-left">map</i>
                    <span class="dropdown-label">{{'StateProvince' | translate}}</span>
                    <input type="text" class="CustomDropdownInput" [(ngModel)]="this.CurrentOrder.ShippingAddress.State" />
                  </div>
                </div>

                <!-- City -->
                <div class="CustomDropdownContainer EditField">
                  <div class="CustomDropdownBar CustomDropdownBarInput">
                    <i class="material-icons dropdown-icon-left">location_city</i>
                    <span class="dropdown-label">{{'Partners.PartnerWindow.City' | translate}}</span>
                    <input type="text" class="CustomDropdownInput" [(ngModel)]="this.CurrentOrder.ShippingAddress.City" />
                  </div>
                </div>

                <!-- Zip Code -->
                <div class="CustomDropdownContainer EditField">
                  <div class="CustomDropdownBar CustomDropdownBarInput">
                    <i class="material-icons dropdown-icon-left">markunread_mailbox</i>
                    <span class="dropdown-label">{{'ZipCode' | translate}}</span>
                    <input type="text" class="CustomDropdownInput" style="letter-spacing: 2px;font-weight: 600;" [(ngModel)]="this.CurrentOrder.ShippingAddress.ZipCode" />
                  </div>
                </div>

                <!-- Address Line -->
                <div class="CustomDropdownContainer EditFieldFull">
                  <div class="CustomDropdownBar CustomDropdownBarInput">
                    <i class="material-icons dropdown-icon-left">home</i>
                    <span class="dropdown-label">{{'Partners.PartnerWindow.AddressLine' | translate}}</span>
                    <input type="text" class="CustomDropdownInput" [(ngModel)]="this.CurrentOrder.ShippingAddress.AddressLine" />
                  </div>
                </div>
              </ng-container>
            </div>

            <!-- ✅ Delimiter -->
            <div class="ShippingSectionDelimiter"></div>

            <!-- ✅ Shipping Settings -->
            <div class="EditFieldsGrid EditFieldsGridCustom">
              <!-- Shipping Responsability -->
              <div class="CustomDropdownContainer CustomDropdownContainerUpward EditField" [class.locked]="this.CurrentOrder.Cart?.LockShippingSettings">
                <div class="DropdownOverlayTransparent" *ngIf="showShippingResponsabilityDropdown && !this.CurrentOrder.Cart?.LockShippingSettings" (click)="showShippingResponsabilityDropdown = false"></div>
                <div class="CustomDropdownBar" (click)="!this.CurrentOrder.Cart?.LockShippingSettings && (showShippingResponsabilityDropdown = !showShippingResponsabilityDropdown)">
                  <i class="material-icons dropdown-icon-left">assignment_ind</i>
                  <span class="dropdown-label">{{'ShippingResponsability' | translate}}</span>
                  <input type="text" class="CustomDropdownInput" readonly
                         [class.placeholder]="!this.CurrentOrder.Cart?.ShippingResponsability"
                         [value]="this.CurrentOrder.Cart?.ShippingResponsability?.Name || 'Select...'" />
                  <i class="material-icons dropdown-icon" *ngIf="!this.CurrentOrder.Cart?.LockShippingSettings">arrow_drop_up</i>
                  <i class="material-icons dropdown-icon locked-icon" *ngIf="this.CurrentOrder.Cart?.LockShippingSettings">lock</i>
                </div>
                <div class="CustomDropdownResults CustomDropdownResultsUpward" *ngIf="showShippingResponsabilityDropdown && !this.CurrentOrder.Cart?.LockShippingSettings">
                  <div class="CustomDropdownResult" *ngFor="let item of ShippingResponsabilities"
                       (click)="selectShippingResponsability(item)">
                    <div class="CustomDropdownResultMain">
                      <span class="CustomDropdownResultText">{{item.Name}}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Shipping Service Type (hidden when EXW selected) -->
              <div class="CustomDropdownContainer CustomDropdownContainerUpward EditField" [class.locked]="this.CurrentOrder.Cart?.LockShippingSettings" *ngIf="this.CurrentOrder.Cart?.ShippingResponsability?.ID !== 0">
                <div class="DropdownOverlayTransparent" *ngIf="showShippingServiceTypeDropdown && !this.CurrentOrder.Cart?.LockShippingSettings" (click)="showShippingServiceTypeDropdown = false"></div>
                <div class="CustomDropdownBar" (click)="!this.CurrentOrder.Cart?.LockShippingSettings && (showShippingServiceTypeDropdown = !showShippingServiceTypeDropdown)">
                  <i class="material-icons dropdown-icon-left">speed</i>
                  <span class="dropdown-label">{{'ShippingServiceType' | translate}}</span>
                  <input type="text" class="CustomDropdownInput" readonly
                         [class.placeholder]="!this.CurrentOrder.Cart?.ShippingServiceType"
                         [value]="this.CurrentOrder.Cart?.ShippingServiceType?.Name || 'Select...'" />
                  <i class="material-icons dropdown-icon" *ngIf="!this.CurrentOrder.Cart?.LockShippingSettings">arrow_drop_up</i>
                  <i class="material-icons dropdown-icon locked-icon" *ngIf="this.CurrentOrder.Cart?.LockShippingSettings">lock</i>
                </div>
                <div class="CustomDropdownResults CustomDropdownResultsUpward" *ngIf="showShippingServiceTypeDropdown && !this.CurrentOrder.Cart?.LockShippingSettings">
                  <div class="CustomDropdownResult" *ngFor="let item of ShippingServiceTypes"
                       (click)="selectShippingServiceType(item)">
                    <div class="CustomDropdownResultMain">
                      <span class="CustomDropdownResultText">{{item.Name}}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Shipping Company (hidden when EXW selected) -->
              <div class="CustomDropdownContainer CustomDropdownContainerUpward EditField" [class.locked]="this.CurrentOrder.Cart?.LockShippingSettings" *ngIf="this.CurrentOrder.Cart?.ShippingResponsability?.ID !== 0">
                <div class="DropdownOverlayTransparent" *ngIf="showShippingCompanyDropdown && !this.CurrentOrder.Cart?.LockShippingSettings" (click)="showShippingCompanyDropdown = false"></div>
                <div class="CustomDropdownBar" (click)="!this.CurrentOrder.Cart?.LockShippingSettings && (showShippingCompanyDropdown = !showShippingCompanyDropdown)">
                  <i class="material-icons dropdown-icon-left">local_shipping</i>
                  <span class="dropdown-label">{{'ShippingCompany' | translate}}</span>
                  <input type="text" class="CustomDropdownInput" readonly
                         [class.placeholder]="!this.CurrentOrder.Cart?.ShippingCompany"
                         [value]="this.CurrentOrder.Cart?.ShippingCompany?.Name || 'Select...'" />
                  <i class="material-icons dropdown-icon" *ngIf="!this.CurrentOrder.Cart?.LockShippingSettings">arrow_drop_up</i>
                  <i class="material-icons dropdown-icon locked-icon" *ngIf="this.CurrentOrder.Cart?.LockShippingSettings">lock</i>
                </div>
                <div class="CustomDropdownResults CustomDropdownResultsUpward" *ngIf="showShippingCompanyDropdown && !this.CurrentOrder.Cart?.LockShippingSettings">
                  <div class="CustomDropdownResult" *ngFor="let item of ShippingCompanies"
                       (click)="selectShippingCompany(item)">
                    <div class="CustomDropdownResultMain">
                      <span class="CustomDropdownResultText">{{item.Name}}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Shipping Cost + Currency -->
              <div class="CustomDropdownContainer EditField">
                <div class="CustomDropdownBar CustomDropdownBarInput">
                  <i class="material-icons dropdown-icon-left">payments</i>
                  <span class="dropdown-label">{{'ShippingCost' | translate}}</span>
                  <input type="number" class="CustomDropdownInput" style="font-weight: 600;"
                         [(ngModel)]="this.CurrentOrder.Cart.ShippingCost.UIUnitPrice"
                         placeholder="0.00" />
                  <span class="ShippingCostCurrency">{{this.CurrentOrder.Cart?.Currency?.Symbol || this.CurrentOrder.Cart?.Currency?.Name || ''}}</span>
                </div>
              </div>

              <!-- Weight Type Dropdown -->
              <div class="CustomDropdownContainer EditField">
                <div class="DropdownOverlayTransparent" *ngIf="showWeightTypeDropdown" (click)="showWeightTypeDropdown = false"></div>
                <div class="CustomDropdownBar" (click)="showWeightTypeDropdown = !showWeightTypeDropdown">
                  <i class="material-icons dropdown-icon-left">scale</i>
                  <span class="dropdown-label">{{'WeightType' | translate}}</span>
                  <input type="text" class="CustomDropdownInput" readonly
                         [class.placeholder]="!this.CurrentOrder?.Cart?.WeightMeasurementType"
                         [value]="this.CurrentOrder?.Cart?.WeightMeasurementType?.Name || 'Select...'" />
                  <i class="material-icons dropdown-icon">arrow_drop_down</i>
                </div>
                <div class="CustomDropdownResults CustomDropdownResultsUpward" *ngIf="showWeightTypeDropdown">
                  <div class="CustomDropdownResult" *ngFor="let wt of parent.CartMasterData?.WeightTypes"
                       (click)="selectWeightType(wt)">
                    <div class="CustomDropdownResultMain">
                      <i class="material-icons" [style.color]="CurrentOrder?.Cart?.WeightMeasurementType?.ID === wt.ID ? '#10b981' : '#9ca3af'">
                        {{ CurrentOrder?.Cart?.WeightMeasurementType?.ID === wt.ID ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <span class="CustomDropdownResultText">{{wt.Name}}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Weight Input -->
              <div class="CustomDropdownContainer EditField">
                <div class="CustomDropdownBar CustomDropdownBarInput"
                     [style.border]="this.CurrentOrder?.Cart?.ForcedUIWeight ? '2px solid #ff6600' : ''">
                  <i class="material-icons dropdown-icon-left">fitness_center</i>
                  <span class="dropdown-label">{{'Weight' | translate}}</span>
                  <input type="number" step="0.01" class="CustomDropdownInput"
                         [style.font-weight]="600"
                         [(ngModel)]="this.CurrentOrder.Cart.Weight"
                         (ngModelChange)="onWeightChange($event)"
                         placeholder="0.00" />
                </div>
              </div>
            </div>

            <!-- ✅ Products Insurance Section (shown when DAP, DDP, or FCA selected) -->
            <div class="InsuranceContainer" *ngIf="this.CurrentOrder.Cart?.ShippingResponsability?.RequiresInsurance != null">
              <mat-slide-toggle
                matTooltip="{{ 'RequestProductsInsuranceDescription' | translate}}"
                matTooltipClass='neutral-tool-tip'
                class="InsuranceToggleSetting"
                [(ngModel)]="this.CurrentOrder.Cart.HasInsurance">
              </mat-slide-toggle>
              <span class="InsuranceContainerInfo">{{ 'RequestProductsInsuranceDescription2' | translate}}</span>
            </div>

           </div>
        </div>

        <div class="EditSection EditSectionProducts">
          <div class="EditSectionHeader" (click)="this.ShowOrderProductsInformation = !this.ShowOrderProductsInformation">
            <div class="EditSectionHeaderLeft">
              <i class="material-icons">shopping_cart</i>
              <span>{{'Products' | translate}}</span>
              <span class="ProductCount">({{this.CurrentOrder.Cart?.Items?.length || 0}})</span>
              <div class="GridCommandButton GridCommandButtonBlue HeaderAddRowsButton" (click)="addMoreRows(50); $event.stopPropagation()">
                <i class="material-icons">add</i>
                <span>{{'AddRows' | translate}}</span>
              </div>
            </div>
            <i class="material-icons EditSectionToggle">{{this.ShowOrderProductsInformation ? 'expand_less' : 'expand_more'}}</i>
          </div>

          <div class="EditSectionBody EditSectionBodyGrid" *ngIf="this.ShowOrderProductsInformation == true;">
            <!-- AG Grid Container - same as Products tab -->
            <!-- ✅ Overlay for popups -->
            <div class="overlayTransparent"
                 *ngIf="ShowETAAlternatives == true || ShowSupplierAlternatives == true || ShowBrandCollateral == true || ShowFallbackSelection == true || ShowPartnerSearchPopup == true || ShowCOOSearchPopup == true"
                 (click)="closeAllPopups();">
            </div>

            <div class="ProductsAGGridContainer" (click)="onGridCellButtonClick($event)">
              <!-- ✅ Excel Export Column Control Row - aligned with ag-Grid columns (must match productsColumnDefs order) -->
              <div class="ExcelExportControlRow" *ngIf="CurrentOrder?.PDFColumns">
                <!-- 1. index -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('index')">
                  <mat-checkbox [checked]="allExportColumnsSelected" (change)="toggleAllExportColumns($event.checked)" color="primary"></mat-checkbox>
                </div>
                <!-- 2. partnerName (Partner column) -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('partnerName')"></div>
                <!-- 3. offerRef (Offer column) -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('offerRef')"></div>
                <!-- 4. brand -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('brand')"></div>
                <!-- 5. partNumber -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('partNumber')"></div>
                <!-- 6. name -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('name')"></div>
                <!-- 7. quantity -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('quantity')"></div>
                <!-- 8. officialListPrice -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('officialListPrice')">
                  <mat-checkbox [checked]="CurrentOrder?.PDFColumns?.ListPrice" (change)="onExportColumnChange('ListPrice', $event.checked)" color="primary"></mat-checkbox>
                </div>
                <!-- 9. officialDiscount -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('officialDiscount')">
                  <mat-checkbox [checked]="CurrentOrder?.PDFColumns?.Discount" (change)="onExportColumnChange('Discount', $event.checked)" color="primary"></mat-checkbox>
                </div>
                <!-- 10. price -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('price')"></div>
                <!-- 11. sellCurrency -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('sellCurrency')"></div>
                <!-- 12. total -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('total')"></div>
                <!-- 13. eta -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('eta')">
                  <mat-checkbox [checked]="CurrentOrder?.PDFColumns?.StandardDelivery" (change)="onExportColumnChange('ETA', $event.checked)" color="primary"></mat-checkbox>
                </div>
                <!-- 14. supplier -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('supplier')"></div>
                <!-- 15. purchase -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('purchase')"></div>
                <!-- 16. purchaseCurrency -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('purchaseCurrency')"></div>
                <!-- 17. hscode -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('hscode')">
                  <mat-checkbox [checked]="CurrentOrder?.PDFColumns?.HSCode" (change)="onExportColumnChange('HSCode', $event.checked)" color="primary"></mat-checkbox>
                </div>
                <!-- 18. coo -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('coo')">
                  <mat-checkbox [checked]="CurrentOrder?.PDFColumns?.COO" (change)="onExportColumnChange('COO', $event.checked)" color="primary"></mat-checkbox>
                </div>
                <!-- 19. weight -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('weight')">
                  <mat-checkbox [checked]="CurrentOrder?.PDFColumns?.Weight" (change)="onExportColumnChange('Weight', $event.checked)" color="primary"></mat-checkbox>
                </div>
                <!-- 20. datasheet -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('datasheet')"></div>
                <!-- 21. save -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('save')"></div>
                <!-- 22. delete -->
                <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('delete')"></div>
              </div>

              <ag-grid-angular
                class="ag-theme-alpine admin-grid"
                style="width: 100%;"
                [rowData]="offerGridRowData"
                [columnDefs]="productsColumnDefs"
                [defaultColDef]="productsDefaultColDef"
                [gridOptions]="offerGridOptions"
                (gridReady)="onOfferGridReady($event)"
                (columnResized)="syncColumnWidths()"
                (contextmenu)="$event.preventDefault()">
              </ag-grid-angular>

              <!-- ✅ Name Column Popup (ShowETAAlternatives) - matching original -->
              <div class="SearchResultsAlternativesContainer grid-style-popup animated fadeIn"
                  *ngIf="ShowETAAlternatives === true"
                  [ngStyle]="SearchResultsPosition">

                <div class="SearchResultsHeader">
                  <span>{{ 'OtherOffers' | translate }}</span>
                  <button class="CloseBtn" (click)="ShowETAAlternatives = false">×</button>
                </div>

                <!-- ✅ Tabs for unified popup -->
                <div class="GridModeTabsWrapper">
                  <div class="GridModeTab"
                       [ngClass]="{'SelectedGridModeTab': selectedNamePopupTab === 1}"
                       (click)="onNamePopupTabChange(1)">
                    <span>{{ 'OtherOffers' | translate }}</span>
                  </div>
                  <div class="GridModeTab"
                       [ngClass]="{'SelectedGridModeTab': selectedNamePopupTab === 2}"
                       (click)="onNamePopupTabChange(2)">
                    <span>{{ 'SimilarProducts' | translate }}</span>
                  </div>
                </div>

                <div class="SearchResultsList" *ngIf="LoadingSideOffers === true" style="margin-top: 50px; margin-bottom: 50px;">
                  <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
                </div>

                <!-- ✅ Tab 1: Other Offers -->
                <div class="SearchResultsList" *ngIf="LoadingSideOffers !== true && selectedNamePopupTab === 1">
                  <div class="OfferRow header-row">
                    <div class="GridCell indexx-column" style="font-style: italic;">#</div>
                    <div class="GridCell brand-column" style="font-style: italic;">{{'Brand' | translate}}</div>
                    <div class="GridCell partnumber-column" style="font-style: italic;">{{'ProductCode' | translate}}</div>
                    <div class="GridCell name-column" style="font-style: italic;">{{'ProductName' | translate}}</div>
                    <div class="GridCell qty-column" style="font-style: italic;">min.{{'Quantity' | translate}}</div>
                    <div class="GridCell price-column" style="font-style: italic;">{{'SellPrice' | translate}}</div>
                    <div class="GridCell total-column" style="font-style: italic;">{{'Total' | translate}}</div>
                    <div class="GridCell eta-column" style="font-style: italic;">{{'ETA' | translate}}</div>
                    <div class="GridCell supplier-column" style="font-style: italic;">Supplier</div>
                    <div class="GridCell purchase-column" style="font-style: italic;">Purchase</div>
                    <div class="GridCell hscode-column" style="font-style: italic;">{{'HSCode' | translate}}</div>
                    <div class="GridCell coo-column" style="font-style: italic;">{{'COO' | translate}}</div>
                    <div class="GridCell weight-column" style="font-style: italic;">{{'Weight' | translate}}</div>
                    <div class="GridCell x-column" style="font-style: italic;"></div>
                  </div>
                  <div class="OfferRow"
                      *ngFor="let result of SideOffers; index as i"
                      (click)="SwitchGridProductOffer(result)"
                      [ngClass]="{ 'SelectedRow': result.IsSelected, 'GridValid': result.SelectedOffer?.IsStockOffer == true && result.SelectedOffer?.IsManufacturerStockOffer != true }">
                    <div class="GridCell indexx-column">{{i + 1}}</div>
                    <div class="GridCell brand-column">{{result.Product?.Brand?.Name}}</div>
                    <div class="GridCell partnumber-column">{{result.Product?.PartNumber}}</div>
                    <div class="GridCell name-column">
                      <i class="material-icons SelectedGridRowName" *ngIf="result.IsSelected == true;">check</i>
                      <span>{{result.Product?.Name}}</span>
                      <span class="GridCellSpecialPriceSignal" *ngIf="result.SelectedOffer?.Configuration?.SpecialPriceList == true;">({{'SpecialPriceOffer' | translate}})</span>
                    </div>
                    <div class="GridCell qty-column">{{result.Quantity}}</div>
                    <div class="GridCell price-column">{{result.Price?.UIUnitPrice}} {{result.SelectedOffer?.Currency?.Symbol}}</div>
                    <div class="GridCell total-column">{{result.Price?.UIQtyPrice}} {{result.SelectedOffer?.Currency?.Symbol}}</div>
                    <div class="GridCell eta-column">
                      <span *ngIf="result.SelectedOffer?.LeadTime?.Units > 0">{{result.SelectedOffer.LeadTime.Units}} {{result.SelectedOffer.LeadTime.Type?.Name}}</span>
                      <span *ngIf="!result.SelectedOffer?.LeadTime?.Units || result.SelectedOffer?.LeadTime?.Units <= 0">------</span>
                    </div>
                    <div class="GridCell supplier-column">{{result.SelectedOffer?.Partner?.Name}}</div>
                    <div class="GridCell purchase-column">{{result.SelectedOffer?.ListPrice}} {{result.SelectedOffer?.Currency?.Symbol}}</div>
                    <div class="GridCell hscode-column">{{result.Product?.Stats?.HSCode}}</div>
                    <div class="GridCell coo-column">{{result.Product?.Stats?.COO?.Name}}</div>
                    <div class="GridCell weight-column">{{result.Product?.Stats?.Weight}}</div>
                    <div class="GridCell x-column"></div>
                  </div>
                  <div class="NoAlternatives" *ngIf="SideOffers?.length === 0">
                    No alternatives available
                  </div>
                </div>

                <!-- ✅ Tab 2: Similar Products (placeholder) -->
                <div class="SearchResultsList" *ngIf="LoadingSideOffers !== true && selectedNamePopupTab === 2">
                  <div class="NoAlternatives">
                    Similar products feature coming soon
                  </div>
                </div>
              </div>

              <!-- Brand Collateral Popup (matching original) -->
              <div class="BrandCollateralContainer" *ngIf="ShowBrandCollateral == true" [ngStyle]="BrandPopupPosition">
                <div class="SearchResultsList" *ngIf="LoadingSideOffers === true" style="margin-top: 50px; margin-bottom: 50px; overflow: hidden;">
                  <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
                </div>
                <div *ngIf="LoadingSideOffers != true;" class="SearchResultsList" style="overflow: hidden;">
                  <div class="brand-collateral-item" *ngFor="let b of BrandCollateralList" (click)="SwitchGridBrandVersion2(b);">
                    <span>{{ b?.Name}}</span>
                    <i class="material-icons" *ngIf="b.IsSelected == true;">check</i>
                  </div>
                </div>
              </div>

              <!-- Supplier Alternatives Popup (matching original) -->
              <div class="SearchResultsAlternativesContainer grid-style-popup supplier-alternatives-popup animated fadeIn"
                  *ngIf="ShowSupplierAlternatives === true && LoadingSideOffers !== true && (SideOffers?.length > 0 || SupplierPopupSearchTerm?.length > 0)"
                  [ngStyle]="SupplierPopupPosition">

                <!-- Search Textbox -->
                <div style="padding: 8px; border-bottom: 1px solid #e0e0e0;">
                  <input
                    type="text"
                    class="supplier-popup-search-input"
                    placeholder="Search supplier..."
                    [(ngModel)]="SupplierPopupSearchTerm"
                    (ngModelChange)="SearchSupplierPopup()"
                    style="width: 100%; padding: 6px 10px; border: 1px solid #ddd; border-radius: 4px; font-size: 11px; outline: none; box-sizing: border-box;"
                  />
                </div>

                <!-- Show search results when searching -->
                <div *ngIf="SupplierPopupSearchTerm?.length > 0 && SupplierPopupSearchResults?.length > 0">
                  <div class="supplier-popup-item" *ngFor="let partner of SupplierPopupSearchResults" (click)="SelectPartnerFromSearch(partner)">
                    <div class="supplier-popup-column" style="flex: 1; padding: 8px 12px;">
                      {{ partner?.Name }}
                    </div>
                  </div>
                </div>

                <!-- Show original side offers when NOT searching -->
                <div *ngIf="!SupplierPopupSearchTerm || SupplierPopupSearchTerm?.length === 0">
                  <div class="supplier-popup-item" *ngFor="let cartItem of SideOffers" (click)="SelectSideOffer(cartItem)">
                    <div class="supplier-popup-column supplier-name-column">
                      <span *ngIf="cartItem?.SelectedOffer?.MOQ > 0">[{{ cartItem?.SelectedOffer?.MOQ }}] </span>{{ cartItem?.SelectedOffer?.Partner?.Name || 'N/A' }}
                    </div>
                    <div class="supplier-popup-column purchase-info-column">
                      {{ cartItem?.SelectedOffer?.ListPrice || 'N/A' }} {{ cartItem?.SelectedOffer?.Currency?.Symbol || 'N/A' }}
                    </div>
                    <div class="supplier-popup-column stock-column">
                      <span *ngIf="cartItem?.SelectedOffer?.StockQuantity > 0">STOCK</span>
                    </div>
                    <div class="supplier-popup-column leadtime-column">
                      <span *ngIf="cartItem?.SelectedOffer?.LeadTime?.Units > 0">
                        {{ cartItem.SelectedOffer.LeadTime.Units }} {{ cartItem.SelectedOffer.LeadTime.Type?.Name || '' }}
                      </span>
                      <span *ngIf="!cartItem?.SelectedOffer?.LeadTime?.Units || cartItem?.SelectedOffer?.LeadTime?.Units <= 0">
                        ------
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Loading spinner for supplier popup -->
              <div class="SearchResultsAlternativesContainer grid-style-popup supplier-alternatives-popup animated fadeIn"
                  *ngIf="ShowSupplierAlternatives === true && LoadingSideOffers === true"
                  [ngStyle]="SupplierPopupPosition"
                  style="min-height: 100px; display: flex; align-items: center; justify-content: center;">
                <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
              </div>

              <!-- Partner Search Popup -->
              <div class="PartnerSearchContainer GridModeTabsWrapper"
                   *ngIf="ShowPartnerSearchPopup"
                   [style.top]="SupplierPopupPosition.top"
                   [style.left]="SupplierPopupPosition.left">
                <div class="PopupHeader">
                  <span>Search Supplier</span>
                  <i class="material-icons ClosePopup" (click)="ShowPartnerSearchPopup = false">close</i>
                </div>
                <div class="PopupBody">
                  <input type="text"
                         class="PartnerSearchInput"
                         [(ngModel)]="PartnerSearchTerm"
                         placeholder="Search partner..."
                         (input)="searchPartnerUpdate.next(PartnerSearchTerm)">
                  <div class="PartnerSearchResults" *ngIf="PartnerSearchResults?.length > 0">
                    <div class="PartnerItem"
                         *ngFor="let partner of PartnerSearchResults"
                         (click)="selectPartner(partner)">
                      {{partner?.Name}}
                    </div>
                  </div>
                </div>
              </div>

              <!-- COO Search Popup -->
              <div class="COOSearchContainer GridModeTabsWrapper"
                   *ngIf="ShowCOOSearchPopup"
                   [style.top]="COOPopupPosition.top"
                   [style.left]="COOPopupPosition.left">
                <div class="PopupHeader">
                  <span>Select Country of Origin</span>
                  <i class="material-icons ClosePopup" (click)="ShowCOOSearchPopup = false">close</i>
                </div>
                <div class="PopupBody">
                  <input type="text"
                         class="COOSearchInput"
                         [(ngModel)]="COOSearchTerm"
                         placeholder="Search country...">
                  <div class="COOSearchResults" *ngIf="parent?.masterData?.Countries?.length > 0">
                    <div class="COOItem"
                         *ngFor="let country of parent?.masterData?.Countries"
                         (click)="selectCOO(country)"
                         [class.hidden]="COOSearchTerm && !country?.Name?.toLowerCase().includes(COOSearchTerm.toLowerCase())">
                      {{country?.Name}}
                    </div>
                  </div>
                </div>
              </div>

            </div>




          </div>
        </div>

    </div>

    <!-- Modern Footer -->
    <div class="EditContainerFooter">
      <div class="GridCommandButton GridCommandButtonBlue" (click)="AddNewOffer();" [class.disabled]="this.parent.loading">
        <i class="material-icons" *ngIf="!this.parent.loading">save</i>
        <span *ngIf="!this.parent.loading">{{'Save' | translate}}</span>
        <mat-spinner *ngIf="this.parent.loading" diameter="18"></mat-spinner>
      </div>

      <!-- Auto-Save Toggle for Single-Order Popup Grid -->
      <div class="auto-save-toggle-container" *ngIf="CurrentOrder?.DBID > 0"
           [matTooltip]="'AutoSaveDescription' | translate" matTooltipPosition="above">
        <label class="auto-save-toggle">
          <input type="checkbox" [(ngModel)]="OfferAutoSave">
          <span class="toggle-slider"></span>
        </label>
        <span class="auto-save-label">{{ 'AutoSave' | translate }}</span>
        <div class="auto-save-delay-control" *ngIf="OfferAutoSave">
          <button class="delay-btn" (click)="decreaseAutoSaveDelay()" [disabled]="autoSaveDelay <= 0.25" title="Decrease delay">−</button>
          <span class="delay-value">{{autoSaveDelay.toFixed(2)}}s</span>
          <button class="delay-btn" (click)="increaseAutoSaveDelay()" [disabled]="autoSaveDelay >= 2.00" title="Increase delay">+</button>
        </div>
      </div>

      <!-- Send Email Dropdown + Generate PO Section -->
      <div class="ConvertToOrderSection">
        <!-- Send Email Dropdown -->
        <div class="SendEmailSearchContainer">
          <div class="SendEmailOverlayTransparent" *ngIf="showSendEmailResults" (click)="showSendEmailResults = false"></div>
          <div class="SendEmailSearchBar" (click)="onSendEmailFocus()">
            <span class="send-email-label">{{'SendEmail' | translate}}</span>
            <i class="material-icons send-email-icon" [style.color]="sendEmailOnConvert ? '#ab47bc' : '#f44336'">
              {{ sendEmailOnConvert ? 'check_circle' : 'cancel' }}
            </i>
            <input type="text" class="SendEmailSearchInput" [value]="getSendEmailLabel()" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="SendEmailSearchResults" *ngIf="showSendEmailResults">
            <div class="SendEmailSearchResult" *ngFor="let option of sendEmailOptions" (click)="selectSendEmailOption(option)">
              <div class="SendEmailResultMain">
                <i class="material-icons" [style.color]="option.value ? '#ab47bc' : '#f44336'">
                  {{ option.value ? 'check_circle' : 'cancel' }}
                </i>
                <span class="SendEmailResultLabel">{{option.label}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="GridCommandButton GridCommandButtonOrange" (click)="ShowGeneratePOConfirmation = true;" [class.disabled]="this.parent.loading">
          <i class="material-icons" *ngIf="!this.parent.loading">shopping_cart</i>
          <span *ngIf="!this.parent.loading">{{'GeneratePO' | translate}}</span>
          <mat-spinner *ngIf="this.parent.loading" diameter="18"></mat-spinner>
        </div>
      </div>
    </div>
</div>

<div class="MainOrdersContainer">

  <div class="OrderControlls">
    <!-- Compact Filter Bar -->
    <div class="CompactFilterBar">
      <div class="FilterBarLeft">
        <mat-form-field class="CompactField" appearance="outline">
          <mat-label>{{ 'Receptions.ChoosePeriod' | translate }}</mat-label>
          <mat-select name="Administration" [(ngModel)]="Filter.Period">
            <mat-option *ngFor="let a of this.MasterData.Periods;" [value]="a" (click)="AddActiveFilter(a.Name, 'Period'); applyFilter();">
              {{a.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="CompactField" appearance="outline">
          <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
          <input matInput [matDatepicker]="dp" [formControl]="FromDate" (dateChange)="ClearPeriod()">
          <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
          <mat-datepicker #dp></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="CompactField" appearance="outline">
          <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
          <input matInput [matDatepicker]="dp1" [formControl]="ToDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
          <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
          <mat-datepicker #dp1></mat-datepicker>
        </mat-form-field>

        <button mat-stroked-button class="CompactFilterButton" (click)="applyFilter();">
          <mat-icon>filter_alt</mat-icon>
          <span>{{ 'Filter' | translate }}</span>
        </button>

        <div class="PageTitleBadge">
          <i class="material-icons">shopping_cart</i>
          <span>{{ 'PurchaseOrdersTitle' | translate }}</span>
        </div>
      </div>
    </div>

    <!-- Unified Actions, Search & Pagination Row -->
    <div class="ActionsFilterRow">
        <!-- Left Side: Filters & Actions -->
        <div class="LeftActions">
          <div class="FilterButton noselect" (click)="this.showFilter = !this.showFilter;">
              <i class="material-icons">tune</i>
              <span>Advanced Filters</span>
          </div>

          <div class="FilterButton noselect" *ngIf="AnyChecked" (click)="ShowExportBulkQuestion = true;">
            <i class="material-icons">file_download</i>
            <span>Export</span>
          </div>

          <div class="ActiveFiltersContainer">
            <div class="ActiveFilter" *ngFor="let a of this.activeFilters;" (click)="RemoveActiveFilter(a.ID, a.Type);">
              {{a.Name}}
              <i class="material-icons">close</i>
            </div>
          </div>
        </div>

        <!-- Center: Search (Google Style) -->
        <div class="MainOrdersSearchContainer">
          <input type="text" class="MainOrdersSearch" placeholder="{{'Search' | translate}}" [(ngModel)]="this.Filter.SearchTerm" (ngModelChange)="this.searchMainOrders.next($event)">
          <i class="material-icons" *ngIf="!this.LoadingMainSearchTerm && !(this.Filter?.SearchTerm?.length > 0);" (click)="showOffersTab ? GetOrdersFiltered() : GetProductsFiltered();">search</i>
          <i class="material-icons" *ngIf="!this.LoadingMainSearchTerm && this.Filter?.SearchTerm?.length > 0;" (click)="ResetMainSearch();">close</i>
          <mat-spinner class="smallSpinner MainSearchLoadingSpinner" [diameter]="20" *ngIf="this.LoadingMainSearchTerm == true;"></mat-spinner>
        </div>

        <!-- Right Side: Pagination Info & Controls -->


        <div class="FilterContainer animated fadeIn" *ngIf="showFilter">
            <div class="FilterCloseContainer" (click)="this.showFilter = false;">
                <i class="material-icons">close</i>
            </div>

            <div class="FilterContainerBody">
                <div class="FilterGrid">
                  <!-- Status Dropdown -->
                  <div class="CustomDropdownContainer">
                    <div class="DropdownOverlayTransparent" *ngIf="showStatusDropdown" (click)="showStatusDropdown = false"></div>
                    <div class="CustomDropdownBar" (click)="onStatusDropdownFocus()">
                      <span class="dropdown-label">{{ 'Status' | translate }}</span>
                      <i class="material-icons dropdown-icon-left">flag</i>
                      <i class="material-icons send-email-icon" [style.color]="Filter.IndividualStatus?.ID ? '#4caf50' : '#9ab5d0'">
                        {{ Filter.IndividualStatus?.ID ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <input type="text" class="CustomDropdownInput" [class.placeholder]="!Filter.IndividualStatus?.Name" [value]="Filter.IndividualStatus?.Name || ('Status' | translate)" readonly (click)="onStatusDropdownFocus(); $event.stopPropagation();" />
                      <i class="material-icons dropdown-icon">arrow_drop_down</i>
                    </div>
                    <div class="CustomDropdownResults" *ngIf="showStatusDropdown">
                      <div class="CustomDropdownResult" *ngFor="let d of MasterData.PurchaseOrderStatuses" (click)="selectStatusFilter(d)">
                        <div class="CustomDropdownResultMain">
                          <span class="CustomDropdownResultText">{{d.Name}}</span>
                        </div>
                        <i class="material-icons CustomDropdownResultCheck" *ngIf="Filter.IndividualStatus?.ID === d.ID">check</i>
                      </div>
                    </div>
                  </div>

                  <!-- Currency Dropdown -->
                  <div class="CustomDropdownContainer">
                    <div class="DropdownOverlayTransparent" *ngIf="showCurrencyDropdown" (click)="showCurrencyDropdown = false"></div>
                    <div class="CustomDropdownBar" (click)="onCurrencyDropdownFocus()">
                      <span class="dropdown-label">{{'Currency' | translate}}</span>
                      <i class="material-icons dropdown-icon-left">attach_money</i>
                      <i class="material-icons send-email-icon" [style.color]="Filter.Currency?.ID ? '#4caf50' : '#9ab5d0'">
                        {{ Filter.Currency?.ID ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <input type="text" class="CustomDropdownInput" [class.placeholder]="!Filter.Currency?.Name" [value]="Filter.Currency?.Name || ('Currency' | translate)" readonly (click)="onCurrencyDropdownFocus(); $event.stopPropagation();" />
                      <i class="material-icons dropdown-icon">arrow_drop_down</i>
                    </div>
                    <div class="CustomDropdownResults" *ngIf="showCurrencyDropdown">
                      <div class="CustomDropdownResult" *ngFor="let c of MasterData.Currencies" (click)="selectCurrencyFilter(c)">
                        <div class="CustomDropdownResultMain">
                          <span class="CustomDropdownResultText">{{c.Name}}</span>
                        </div>
                        <i class="material-icons CustomDropdownResultCheck" *ngIf="Filter.Currency?.ID === c.ID">check</i>
                      </div>
                    </div>
                  </div>

                  <!-- Brand Search Dropdown -->
                  <div class="CustomDropdownContainer">
                    <div class="DropdownOverlayTransparent" *ngIf="showBrandDropdown" (click)="showBrandDropdown = false"></div>
                    <div class="CustomDropdownBar" (click)="onBrandDropdownFocus()">
                      <span class="dropdown-label">{{'Brand' | translate}}</span>
                      <i class="material-icons dropdown-icon-left">label</i>
                      <i class="material-icons send-email-icon" [style.color]="Filter.Brand?.ID ? '#4caf50' : '#9ab5d0'">
                        {{ Filter.Brand?.ID ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <input type="text" class="CustomDropdownInput" [class.placeholder]="!brandSearchTerm" placeholder="Search brand..." [(ngModel)]="brandSearchTerm" (ngModelChange)="onBrandSearchInput($event)" (click)="onBrandDropdownFocus(); $event.stopPropagation();" />
                      <i class="material-icons dropdown-clear" *ngIf="brandSearchTerm" (click)="clearBrandFilter(); $event.stopPropagation();">close</i>
                      <i class="material-icons dropdown-icon" *ngIf="!brandSearchTerm">search</i>
                    </div>
                    <div class="CustomDropdownResults" *ngIf="showBrandDropdown && Brands?.length > 0">
                      <div class="CustomDropdownResult" *ngFor="let b of Brands" (click)="selectBrandFilter(b)">
                        <div class="CustomDropdownResultMain">
                          <span class="CustomDropdownResultText">{{b.Name}}</span>
                        </div>
                        <i class="material-icons CustomDropdownResultCheck" *ngIf="Filter.Brand?.ID === b.ID">check</i>
                      </div>
                    </div>
                  </div>

                  <!-- Supplier Search Dropdown -->
                  <div class="CustomDropdownContainer">
                    <div class="DropdownOverlayTransparent" *ngIf="showSupplierDropdown" (click)="showSupplierDropdown = false"></div>
                    <div class="CustomDropdownBar" (click)="onSupplierDropdownFocus()">
                      <span class="dropdown-label">{{'Supplier' | translate}}</span>
                      <i class="material-icons dropdown-icon-left">local_shipping</i>
                      <i class="material-icons send-email-icon" [style.color]="Filter.Supplier?.ID ? '#4caf50' : '#9ab5d0'">
                        {{ Filter.Supplier?.ID ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <input type="text" class="CustomDropdownInput" [class.placeholder]="!supplierSearchTerm" placeholder="Search supplier..." [(ngModel)]="supplierSearchTerm" (ngModelChange)="onSupplierSearchInput($event)" (click)="onSupplierDropdownFocus(); $event.stopPropagation();" />
                      <i class="material-icons dropdown-clear" *ngIf="supplierSearchTerm" (click)="clearSupplierFilter(); $event.stopPropagation();">close</i>
                      <i class="material-icons dropdown-icon" *ngIf="!supplierSearchTerm">search</i>
                    </div>
                    <div class="CustomDropdownResults" *ngIf="showSupplierDropdown && Suppliers?.length > 0">
                      <div class="CustomDropdownResult" *ngFor="let s of Suppliers" (click)="selectSupplierFilter(s)">
                        <div class="CustomDropdownResultMain">
                          <span class="CustomDropdownResultText">{{s.Name}}</span>
                        </div>
                        <i class="material-icons CustomDropdownResultCheck" *ngIf="Filter.Supplier?.ID === s.ID">check</i>
                      </div>
                    </div>
                  </div>

                  <!-- Country Search Dropdown (Shipping Address Country) -->
                  <div class="CustomDropdownContainer">
                    <div class="DropdownOverlayTransparent" *ngIf="showCountryDropdown" (click)="showCountryDropdown = false"></div>
                    <div class="CustomDropdownBar" (click)="onCountryDropdownFocus()">
                      <span class="dropdown-label">{{'Country' | translate}}</span>
                      <i class="material-icons dropdown-icon-left">public</i>
                      <i class="material-icons send-email-icon" [style.color]="Filter.Country?.ID ? '#4caf50' : '#9ab5d0'">
                        {{ Filter.Country?.ID ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <input type="text" class="CustomDropdownInput" [class.placeholder]="!countrySearchTerm" placeholder="Search country..." [(ngModel)]="countrySearchTerm" (ngModelChange)="onCountrySearchInput($event)" (click)="onCountryDropdownFocus(); $event.stopPropagation();" />
                      <i class="material-icons dropdown-clear" *ngIf="countrySearchTerm" (click)="clearCountryFilter(); $event.stopPropagation();">close</i>
                      <i class="material-icons dropdown-icon" *ngIf="!countrySearchTerm">search</i>
                    </div>
                    <div class="CustomDropdownResults" *ngIf="showCountryDropdown && Countries?.length > 0">
                      <div class="CustomDropdownResult" *ngFor="let c of Countries" (click)="selectCountryFilter(c)">
                        <div class="CustomDropdownResultMain">
                          <span class="CustomDropdownResultText">{{c.Name}}</span>
                          <span class="CustomDropdownResultSub" *ngIf="c.ShortName">({{c.ShortName}})</span>
                        </div>
                        <i class="material-icons CustomDropdownResultCheck" *ngIf="Filter.Country?.ID === c.ID">check</i>
                      </div>
                    </div>
                  </div>

                  <!-- Partner Search -->
                  <div class="CustomDropdownContainer FilterFieldFull">
                    <div class="DropdownOverlayTransparent" *ngIf="resultsLength > 0" (click)="resultsLength = 0"></div>
                    <div class="CustomDropdownBar" (click)="InitializePartnersOnClick(this.searchTerm, this.countryID, true);">
                      <span class="dropdown-label">{{ 'SearchClient' | translate }}</span>
                      <i class="material-icons dropdown-icon-left">business</i>
                      <i class="material-icons send-email-icon" [style.color]="Filter.Partner?.ID ? '#4caf50' : '#9ab5d0'">
                        {{ Filter.Partner?.ID ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <input type="text" class="CustomDropdownInput" [class.placeholder]="!searchTerm" placeholder="Name/VAT" [(ngModel)]="searchTerm" (ngModelChange)="searchPartnerUpdate.next($event)" (keydown.enter)="searchTerm = Partners[0]?.Name; Filter.Partner = Partners[0]; AddActiveFilter(Partners[0]?.Name, 'Partner'); applyFilter();" (click)="$event.stopPropagation();" />
                      <i class="material-icons dropdown-clear" *ngIf="searchTerm" (click)="searchTerm=''; Partners.length = 0; resultsLength = 0; Filter.Partner = null; $event.stopPropagation();">close</i>
                      <i class="material-icons dropdown-icon" *ngIf="!searchTerm">search</i>
                    </div>
                    <div class="CustomDropdownResults" *ngIf="resultsLength > 0">
                      <div class="CustomDropdownResult" *ngFor="let p of Partners" (click)="resultsLength = 0; searchTerm = p.Name; Filter.Partner = p; AddActiveFilter(p.Name, 'Partner');">
                        <div class="CustomDropdownResultMain">
                          <span class="CustomDropdownResultText">{{p.Name}} <span style="font-weight: bold;" *ngIf="p.VAT?.length">{{p.VAT}}</span></span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- User Manager Dropdown -->
                  <div class="CustomDropdownContainer">
                    <div class="DropdownOverlayTransparent" *ngIf="showUserManagerDropdown" (click)="showUserManagerDropdown = false"></div>
                    <div class="CustomDropdownBar" (click)="onUserManagerDropdownFocus()">
                      <span class="dropdown-label">{{'UserManager' | translate}}</span>
                      <i class="material-icons dropdown-icon-left">manage_accounts</i>
                      <i class="material-icons send-email-icon" [style.color]="Filter.UserManager?.ID ? '#4caf50' : '#9ab5d0'">
                        {{ Filter.UserManager?.ID ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <input type="text" class="CustomDropdownInput" [class.placeholder]="!Filter.UserManager?.Email" [value]="Filter.UserManager?.Email || ('UserManager' | translate)" readonly (click)="onUserManagerDropdownFocus(); $event.stopPropagation();" />
                      <i class="material-icons dropdown-icon">arrow_drop_down</i>
                    </div>
                    <div class="CustomDropdownResults" *ngIf="showUserManagerDropdown">
                      <div class="CustomDropdownResult" *ngFor="let c of MasterData.UserManagers" (click)="selectUserManagerFilter(c)">
                        <div class="CustomDropdownResultMain">
                          <span class="CustomDropdownResultText">{{c.Email}}</span>
                        </div>
                        <i class="material-icons CustomDropdownResultCheck" *ngIf="Filter.UserManager?.ID === c.ID">check</i>
                      </div>
                    </div>
                  </div>

                  <!-- Progress Status Dropdown -->
                  <div class="CustomDropdownContainer">
                    <div class="DropdownOverlayTransparent" *ngIf="showProgressStatusDropdown" (click)="showProgressStatusDropdown = false"></div>
                    <div class="CustomDropdownBar" (click)="onProgressStatusDropdownFocus()">
                      <span class="dropdown-label">{{ 'ProgressStatus' | translate }}</span>
                      <i class="material-icons dropdown-icon-left">trending_up</i>
                      <i class="material-icons send-email-icon" [style.color]="Filter.CartItemProgressStatus?.ID != null ? '#4caf50' : '#9ab5d0'">
                        {{ Filter.CartItemProgressStatus?.ID != null ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <input type="text" class="CustomDropdownInput" [class.placeholder]="Filter.CartItemProgressStatus?.ID == null" [value]="Filter.CartItemProgressStatus?.Name || ('ProgressStatus' | translate)" readonly (click)="onProgressStatusDropdownFocus(); $event.stopPropagation();" />
                      <i class="material-icons dropdown-icon">arrow_drop_down</i>
                    </div>
                    <div class="CustomDropdownResults" *ngIf="showProgressStatusDropdown">
                      <div class="CustomDropdownResult" *ngFor="let s of MasterData.PurchaseOrderStatuses" (click)="selectProgressStatusFilter(s)">
                        <div class="CustomDropdownResultMain">
                          <span class="CustomDropdownResultText">{{s.Name}}</span>
                        </div>
                        <i class="material-icons CustomDropdownResultCheck" *ngIf="Filter.CartItemProgressStatus?.ID === s.ID">check</i>
                      </div>
                    </div>
                  </div>

                  <!-- TranzactionType Dropdown (Export/Intra-EU/Internal) -->
                  <div class="CustomDropdownContainer">
                    <div class="DropdownOverlayTransparent" *ngIf="showTranzactionTypeDropdown" (click)="showTranzactionTypeDropdown = false"></div>
                    <div class="CustomDropdownBar" (click)="onTranzactionTypeDropdownFocus()">
                      <span class="dropdown-label">{{ 'TranzactionType' | translate }}</span>
                      <i class="material-icons dropdown-icon-left">swap_horiz</i>
                      <i class="material-icons send-email-icon" [style.color]="Filter.TranzactionType?.ID ? '#4caf50' : '#9ab5d0'">
                        {{ Filter.TranzactionType?.ID ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <input type="text" class="CustomDropdownInput" [class.placeholder]="!Filter.TranzactionType?.Name" [value]="Filter.TranzactionType?.Name || ('TranzactionType' | translate)" readonly (click)="onTranzactionTypeDropdownFocus(); $event.stopPropagation();" />
                      <i class="material-icons dropdown-icon">arrow_drop_down</i>
                    </div>
                    <div class="CustomDropdownResults" *ngIf="showTranzactionTypeDropdown">
                      <div class="CustomDropdownResult" *ngFor="let t of MasterData.TranzactionTypes" (click)="selectTranzactionTypeFilter(t)">
                        <div class="CustomDropdownResultMain">
                          <span class="CustomDropdownResultText">{{t.Name}}</span>
                        </div>
                        <i class="material-icons CustomDropdownResultCheck" *ngIf="Filter.TranzactionType?.ID === t.ID">check</i>
                      </div>
                    </div>
                  </div>

                  <!-- User Search -->
                  <div class="CustomDropdownContainer FilterFieldFull">
                    <div class="DropdownOverlayTransparent" *ngIf="UserClientsLength > 0" (click)="UserClientsLength = 0"></div>
                    <div class="CustomDropdownBar" (click)="InitializeUserClientsOnClick(UserClientsSearchTerm);">
                      <span class="dropdown-label">{{ 'SearchUser' | translate }}</span>
                      <i class="material-icons dropdown-icon-left">person_search</i>
                      <i class="material-icons send-email-icon" [style.color]="Filter.UserUploader?.ID ? '#4caf50' : '#9ab5d0'">
                        {{ Filter.UserUploader?.ID ? 'check_circle' : 'radio_button_unchecked' }}
                      </i>
                      <input type="text" class="CustomDropdownInput" [class.placeholder]="!UserClientsSearchTerm" placeholder="Email" [(ngModel)]="UserClientsSearchTerm" (ngModelChange)="searchB2BUser.next($event)" (keydown.enter)="UserClientsSearchTerm = UserClients[0]?.Email; Filter.UserUploader = UserClients[0]; AddActiveFilter(UserClients[0]?.Email, 'UserUploader'); applyFilter();" (click)="$event.stopPropagation();" />
                      <i class="material-icons dropdown-clear" *ngIf="UserClientsSearchTerm?.length > 0" (click)="UserClientsSearchTerm=''; UserClients.length = 0; UserClientsLength = 0; Filter.UserUploader = null; $event.stopPropagation();">close</i>
                      <i class="material-icons dropdown-icon" *ngIf="!UserClientsSearchTerm">search</i>
                    </div>
                    <div class="CustomDropdownResults" *ngIf="UserClientsLength > 0">
                      <div class="CustomDropdownResult" *ngFor="let u of UserClients" (click)="UserClientsLength = 0; UserClientsSearchTerm = u.Email; Filter.UserUploader = u; AddActiveFilter(u.Email, 'UserUploader');">
                        <div class="CustomDropdownResultMain">
                          <span class="CustomDropdownResultText">{{u.Email}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>

            <div class="FilterCommands">
                <button mat-raised-button color="primary" class="FilterButtonAction" (click)="applyFilter();">{{ 'Filter' | translate }}</button>
            </div>
        </div>


    </div>
  </div>

  <!-- Unified Pagination Row -->
  <div class="ProductsPaginationRow">
    <!-- Offers Pagination -->
    <ng-container *ngIf="showOffersTab">
      <div class="PaginationInfo">
        <span>{{Orders?.length}} {{'OfWord' | translate}} {{Filter.Pager.TotalCount}} {{'Orders' | translate}}</span>
      </div>
      <div class="PaginationControls">
        <button mat-stroked-button class="PaginationButton" [disabled]="Filter.Pager.PageIndex == 1" (click)="GetOrdersFiltered(1);">
          <mat-icon>first_page</mat-icon>
        </button>
        <button mat-stroked-button class="PaginationButton" [disabled]="Filter.Pager.PageIndex == 1" (click)="GetOrdersFiltered(Filter.Pager.PageIndex - 1);">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <div class="PageNumberDisplay">
          <span class="CurrentPage">{{Filter.Pager.PageIndex}}</span>
          <span class="PageSeparator">/</span>
          <span class="TotalPages">{{Filter.Pager.Pages}}</span>
        </div>
        <button mat-stroked-button class="PaginationButton" [disabled]="Filter.Pager.PageIndex == Filter.Pager.Pages" (click)="GetOrdersFiltered(Filter.Pager.PageIndex + 1);">
          <mat-icon>chevron_right</mat-icon>
        </button>
        <button mat-stroked-button class="PaginationButton" [disabled]="Filter.Pager.PageIndex == Filter.Pager.Pages" (click)="GetOrdersFiltered(Filter.Pager.Pages);">
          <mat-icon>last_page</mat-icon>
        </button>
        <input type="number" class="PageSizeInput" [(ngModel)]="Filter.Pager.PageSize" (change)="GetOrdersFiltered(1)" min="10" max="500" title="Page Size">
      </div>
      <!-- Minimalist grid saving indicator (right side) for Offers tab -->
      <div class="grid-saving-indicator" *ngIf="savingGridRow">
        <div class="grid-saving-spinner"></div>
        <span>{{ 'SavingRows' | translate }}</span>
      </div>
    </ng-container>
    <!-- Products Pagination -->
    <ng-container *ngIf="!showOffersTab">
      <div class="PaginationInfo">
        <span>{{ProductItems?.length}} {{'OfWord' | translate}} {{ProductsPager?.TotalCount}} {{'Products' | translate}}</span>
      </div>
      <div class="PaginationControls">
        <button mat-stroked-button class="PaginationButton" [disabled]="ProductsPager?.PageIndex == 1" (click)="GetProductsFiltered(1);">
          <mat-icon>first_page</mat-icon>
        </button>
        <button mat-stroked-button class="PaginationButton" [disabled]="ProductsPager?.PageIndex == 1" (click)="GetProductsFiltered(ProductsPager?.PageIndex - 1);">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <div class="PageNumberDisplay">
          <span class="CurrentPage">{{ProductsPager?.PageIndex}}</span>
          <span class="PageSeparator">/</span>
          <span class="TotalPages">{{ProductsPager?.Pages}}</span>
        </div>
        <button mat-stroked-button class="PaginationButton" [disabled]="ProductsPager?.PageIndex == ProductsPager?.Pages" (click)="GetProductsFiltered(ProductsPager?.PageIndex + 1);">
          <mat-icon>chevron_right</mat-icon>
        </button>
        <button mat-stroked-button class="PaginationButton" [disabled]="ProductsPager?.PageIndex == ProductsPager?.Pages" (click)="GetProductsFiltered(ProductsPager?.Pages);">
          <mat-icon>last_page</mat-icon>
        </button>
        <input type="number" class="PageSizeInput" [(ngModel)]="Filter.Pager.PageSize" (change)="GetProductsFiltered(1)" min="10" max="500" title="Page Size">
        <!-- Auto-Save Toggle -->
        <div class="auto-save-toggle-container">
          <label class="auto-save-toggle">
            <input type="checkbox" [(ngModel)]="AutoSave">
            <span class="toggle-slider"></span>
          </label>
          <span class="auto-save-label">Auto-Save</span>
          <div class="auto-save-delay-control" *ngIf="AutoSave">
            <button class="delay-btn" (click)="decreaseAutoSaveDelay()" [disabled]="autoSaveDelay <= 0.25" title="Decrease delay">−</button>
            <span class="delay-value">{{autoSaveDelay.toFixed(2)}}s</span>
            <button class="delay-btn" (click)="increaseAutoSaveDelay()" [disabled]="autoSaveDelay >= 2.00" title="Increase delay">+</button>
          </div>
        </div>
      </div>
      <!-- Save All After Undo Button - appears after undo to persist changes to DB -->
      <button mat-stroked-button class="CompactFilterButton SaveAfterUndoButton"
              *ngIf="showSaveAfterUndo && !savingGridRow"
              (click)="SaveAllCartItemsAfterUndo()"
              title="Save all items to persist the undo changes">
        <mat-icon style="font-size: 13px; height: 13px; width: 13px;">save</mat-icon>
        <span>{{ 'SaveAll' | translate }}</span>
      </button>
      <!-- Undo Button - only show when there's actually something to undo to (count > 1) -->
      <button mat-stroked-button class="CompactFilterButton UndoButton"
              *ngIf="undoSnapshotCount > 1 && !savingGridRow"
              (click)="undoLastChange()"
              [title]="'Undo last change (' + (undoSnapshotCount - 1) + ' steps available)'">
        <mat-icon style="font-size: 13px; height: 13px; width: 13px;">undo</mat-icon>
        <span class="undo-count-badge">{{undoSnapshotCount - 1}}</span>
      </button>
      <button mat-stroked-button class="CompactFilterButton"
              *ngIf="hasSelectedCartItems() && !savingGridRow"
              (click)="SaveAllSelectedCartItems()"
              title="Save all selected rows"
              style="margin-left: auto; margin-top: 0px;">
        <mat-icon style="font-size: 13px; height: 13px; width: 13px;">save</mat-icon> Save
      </button>
      <!-- Minimalist grid saving indicator (right side) -->
      <div class="grid-saving-indicator" *ngIf="savingGridRow">
        <div class="grid-saving-spinner"></div>
        <span>{{ 'SavingRows' | translate }}</span>
      </div>
    </ng-container>
  </div>

  <!-- Tab Switcher: Offers / Products -->
  <div class="GridModeTabsWrapper">
    <div class="GridModeTab" [ngClass]="{'SelectedGridModeTab': showOffersTab}" (click)="showOffersTab = true; GetOrdersFiltered();">
      <i class="material-icons">description</i>
      <span>{{ 'PurchaseOrdersTitle' | translate }}</span>
    </div>
    <div class="GridModeTab" [ngClass]="{'SelectedGridModeTab': !showOffersTab}" (click)="showOffersTab = false; GetProductsFiltered();">
      <i class="material-icons">inventory_2</i>
      <span>{{ 'Products' | translate }}</span>
    </div>
  </div>

  <!-- Modern Card-Based List -->
  <div class="OrdersListContainer" *ngIf="showOffersTab">
    <div class="OrdersBody" *ngIf="this.loadingOrders == true;">
        <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
    </div>

    <div class="OrdersBody" *ngIf="this.loadingOrders != true;">
        <div class="OrderCardRow" [class.selected]="CurrentOrder?.ID == o.ID" *ngFor="let o of this.Orders; let i = index" (dblclick)="GetOffer(o.ID);">
            <!-- Client & Ref -->
            <div class="OrderRowSection OrderRowClient">
              <i class="material-icons">business</i>
              <span class="OrderRowIndex">#{{i + 1}}</span>
              <div class="OrderRowContent">
                <span class="OrderRowLabel">{{'Client' | translate}}</span>
                <span class="OrderRowValue ClientName" (click)="GetOffer(o.ID);">{{o.Cart?.Partner?.Name}}</span>
                <div class="OrderRowMeta">
                  <span class="OrderRefNumber">{{o.ReferenceNumber}}</span>
                  <span class="OrderDebatorPO" *ngIf="o?.DebatorPO?.length > 0;">{{o.DebatorPO}}</span>
                </div>
              </div>
            </div>

            <!-- Date -->
            <div class="OrderRowSection">
              <i class="material-icons">event</i>
              <div class="OrderRowContent">
                <span class="OrderRowLabel">{{'Date' | translate}}</span>
                <span class="OrderRowValue">{{o.EventRegisterUI}}</span>
              </div>
            </div>

            <!-- Agent -->
            <div class="OrderRowSection">
              <i class="material-icons">person</i>
              <div class="OrderRowContent">
                <span class="OrderRowLabel">{{'Agent' | translate}}</span>
                <span class="OrderRowValue">{{o.UserManager.Email}}</span>
              </div>
            </div>

            <!-- Payment -->
            <div class="OrderRowSection">
              <i class="material-icons">payment</i>
              <div class="OrderRowContent">
                <span class="OrderRowLabel">{{'Payment' | translate}}</span>
                <span class="OrderRowValue">{{o.Cart.PaymentType.Name}}</span>
              </div>
            </div>

            <!-- Compact Shipping & Totals Section -->
            <div class="OrderRowSection OrderRowShippingTotals">
              <i class="material-icons">local_shipping</i>
              <div class="OrderRowShippingTotalsContent">

                <!-- Left Column: Shipping Metadata -->
                <div class="OrderRowShippingMeta">
                  <span class="OrderRowLabel">{{'Shipping' | translate}}</span>
                  <div class="OrderRowShippingBadges">
                    <span class="ShippingBadge" *ngIf="o.Cart?.ShippingCompany?.Name">{{o.Cart.ShippingCompany.Name}}</span>
                    <span class="ShippingBadge" *ngIf="o.Cart?.ShippingServiceType?.Name">{{o.Cart.ShippingServiceType.Name}}</span>
                    <span class="ShippingBadge" *ngIf="o.Cart?.ShippingResponsability?.Name">{{o.Cart.ShippingResponsability.Name}}</span>
                    <span class="ShippingBadge" *ngIf="o.Cart?.DeliveryPreference?.Name">{{o.Cart.DeliveryPreference.Name}}</span>
                  </div>
                </div>

                <!-- Right Column: Totals -->
                <div class="OrderRowTotalsCompact">
                  <!-- Subtotal (OriginalTotal before discount) -->
                  <div class="OrderRowTotalLine" *ngIf="o.Cart?.OriginalTotal?.TotalQtyPriceNOVAT">
                    <span class="OrderRowTotalLabel">{{'Subtotal' | translate}}:</span>
                    <span class="OrderRowTotalValue">{{o.Cart.OriginalTotal.TotalQtyPriceNOVAT | number:'1.2-2'}} {{o.Cart?.Currency?.Name}}</span>
                  </div>

                  <!-- Discount (only if exists and > 0) -->
                  <div class="OrderRowTotalLine OrderRowDiscount" *ngIf="o.Cart?.Total?.Discount?.Value > 0">
                    <span class="OrderRowTotalLabel">{{'Discount' | translate}}:</span>
                    <span class="OrderRowTotalValue" *ngIf="o.Cart.Total.Discount.Type?.ID === 1">-{{o.Cart.Total.Discount.Value | number:'1.0-2'}}%</span>
                    <span class="OrderRowTotalValue" *ngIf="o.Cart.Total.Discount.Type?.ID === 2">-{{o.Cart.Total.Discount.Value | number:'1.2-2'}} {{o.Cart?.Currency?.Name}}</span>
                  </div>

                  <!-- Subtotal after discount (only if discount exists) -->
                  <div class="OrderRowTotalLine" *ngIf="o.Cart?.Total?.Discount?.Value > 0 && o.Cart?.Total?.TotalQtyPriceNOVAT">
                    <span class="OrderRowTotalLabel">{{'SubtotalAfterDiscount' | translate}}:</span>
                    <span class="OrderRowTotalValue">{{o.Cart.Total.TotalQtyPriceNOVAT | number:'1.2-2'}} {{o.Cart?.Currency?.Name}}</span>
                  </div>

                  <!-- Shipping Cost -->
                  <div class="OrderRowTotalLine">
                    <span class="OrderRowTotalLabel">{{'ShippingCost' | translate}}:</span>
                    <span class="OrderRowTotalValue">{{(o.Cart?.ShippingCost?.UIUnitPrice || 0) | number:'1.2-2'}} {{o.Cart?.Currency?.Name}}</span>
                  </div>

                  <!-- Grand Total -->
                  <div class="OrderRowTotalLine OrderRowGrandTotal">
                    <span class="OrderRowTotalLabel">{{'GrandTotal' | translate}}:</span>
                    <span class="OrderRowTotalValue OrderRowValueBold">
                      {{((o.Cart?.ShippingCost?.UIUnitPrice || 0) + (o.Cart?.Total?.TotalQtyPriceNOVAT || 0)) | number:'1.2-2'}} {{o.Cart?.Currency?.Name}}
                    </span>
                  </div>
                </div>

              </div>
            </div>

            <!-- Status Dropdown -->
            <div class="OrderRowSection OrderRowStatus">
              <div class="StatusDropdownContainer" *ngIf="o.POStatus?.ID != 11">
                <span class="OrderStatusBadge StatusDropdownTrigger" [ngClass]="{
                  'StatusNew': o.POStatus?.ID == -1,
                  'StatusProcessing': o.POStatus?.ID == 1,
                  'StatusPartial': o.POStatus?.ID == 9,
                  'StatusConfirmed': o.POStatus?.ID == 10 || o.POStatus?.ID == 12,
                  'StatusCanceled': o.POStatus?.ID == 11
                }" (click)="togglePOStatusDropdown(o, $event)" matTooltip="{{o.POStatus?.Description}} → {{o.POStatus?.NextStep}}" matTooltipClass='neutral-tool-tip'>
                  {{o.POStatus?.Name}}
                  <i class="material-icons StatusDropdownIcon">arrow_drop_down</i>
                </span>
                <div class="StatusDropdownOptions" *ngIf="o.showStatusDropdown">
                  <ng-container *ngFor="let status of MasterData?.PurchaseOrderStatuses">
                    <div class="StatusDropdownOption"
                         *ngIf="status.ID != 11"
                         [ngClass]="{
                           'StatusNew': status.ID == -1 || status.ID == 0,
                           'StatusProcessing': status.ID == 1,
                           'StatusPartial': status.ID == 9 || status.ID == 8,
                           'StatusConfirmed': status.ID == 10 || status.ID == 12 || status.ID == 2 || status.ID == 6 || status.ID == 7,
                           'StatusSelected': status.ID == o.POStatus?.ID
                         }"
                         (click)="OnPOStatusChange(o, status); $event.stopPropagation();">
                      {{status.Name}}
                    </div>
                  </ng-container>
                </div>
              </div>
              <!-- Static badge for canceled orders (cannot change status) -->
              <span class="OrderStatusBadge StatusCanceled" *ngIf="o.POStatus?.ID == 11" matTooltip="{{o.POStatus?.Description}}" matTooltipClass='neutral-tool-tip'>
                {{o.POStatus?.Name}}
              </span>
              <div class="StatusIndicator" *ngIf="o.ProcessingStatus?.ID == 0;" matTooltip="{{'NeedsWork' | translate}}" matTooltipClass='neutral-tool-tip'></div>
            </div>

            <!-- Actions -->
            <div class="OrderRowSection OrderRowActions">
              <button mat-icon-button (click)="GetOffer(o.ID);" matTooltip="{{'Edit' | translate}}" matTooltipClass='neutral-tool-tip'>
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button (click)="ExportOrder(o);" matTooltip="{{'PDF' | translate}}" matTooltipClass='neutral-tool-tip'>
                <mat-icon>picture_as_pdf</mat-icon>
              </button>
              <button mat-icon-button (click)="ExportOrderExcel(o);" matTooltip="{{'ExportExcel' | translate}}" matTooltipClass='neutral-tool-tip'>
                <mat-icon>grid_on</mat-icon>
              </button>
            </div>

            <!-- Error Indicator -->
            <div class="OrderRowError" *ngIf="o.InjectionError?.HasError == true || o.InjectionError?.Message?.length > 0;"
                 matTooltip="{{o.InjectionError?.Message || 'APIInjectionError'}}" matTooltipClass='neutral-tool-tip'>
              <i class="material-icons">error</i>
            </div>
        </div>
    </div>
  </div>

  <!-- Products Tab Content -->
  <div class="ProductsListContainer" *ngIf="!showOffersTab">
    <!-- ✅ Deselect overlay - covers header/filter area above the grid, clicking deselects all -->
    <div class="deselect-above-grid-overlay"
         *ngIf="hasSelectedCartItems()"
         (click)="deselectAllProductItems()"
         #deselectOverlay>
    </div>

    <div class="OrdersBody" *ngIf="loadingProducts">
      <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
    </div>

    <div class="ProductsGrid" *ngIf="!loadingProducts">
      <!-- Products AG Grid -->
      <div class="ProductsAGGridContainer" (click)="onProductsGridCellButtonClick($event)">
        <!-- Backdrop for popups -->
        <div class="PopupBackdrop"
             *ngIf="ShowProductsETAAlternatives == true || ShowProductsSupplierAlternatives == true || ShowProductsBrandCollateral == true || showPurchaseCurrencyDropdown == true || showSupplierPopup == true || showBrandPopup == true || showPartnerPopup == true || showProgressStatusFilterPopup == true"
             (click)="closeProductsPopups(); showSupplierPopup = false; Suppliers = []; showBrandPopup = false; Brands = []; showPartnerPopup = false; Partners = []; showProgressStatusFilterPopup = false;">
        </div>

        <!-- Custom Header Overlays for Filter Buttons -->
        <ng-container *ngIf="gridHeaderWidths && gridHeaderWidths.length > 0">
          <ng-container *ngFor="let col of gridHeaderWidths">

            <!-- Brand Filter Overlay -->
            <div class="custom-header-overlay filter-cell"
                 *ngIf="col.field === 'brand'"
                 [style.width.px]="col.width"
                 [style.left.px]="col.left">
              <div class="filter-controls">
                <button *ngIf="Filter.Brand?.ID" class="filter-clear-btn"
                        (click)="clearBrandFilter(); $event.stopPropagation();">
                  <i class="material-icons">close</i>
                </button>
                <button class="filter-dropdown-btn" (click)="openBrandPopup()">
                  <i class="material-icons">expand_more</i>
                </button>
              </div>

              <!-- Brand Filter Popup -->
              <div class="SearchResultsAlternativesContainer grid-style-popup supplier-alternatives-popup"
                   *ngIf="showBrandPopup"
                   style="position: absolute; top: 100%; left: 0; min-width: 300px; z-index: 10000;">
                <div style="padding: 8px; border-bottom: 1px solid #e0e0e0;">
                  <input type="text" class="supplier-popup-search-input" placeholder="Search brand..."
                         [(ngModel)]="brandSearchTerm" (ngModelChange)="brandSearchTermUpdate.next($event)"
                         style="width: 100%; padding: 6px 10px; border: 1px solid #ddd; border-radius: 4px; font-size: 11px; outline: none; box-sizing: border-box;" />
                </div>
                <div *ngIf="loadingBrands" style="padding: 15px; text-align: center;">
                  <mat-spinner [diameter]="20"></mat-spinner>
                </div>
                <div *ngIf="!loadingBrands && Brands?.length > 0" style="max-height: 250px; overflow-y: auto;">
                  <div class="supplier-popup-item" *ngFor="let b of Brands" (click)="selectBrandFilter(b)">
                    <div class="supplier-popup-column" style="flex: 1; padding: 8px 12px;">
                      {{ b?.Name }}
                      <i class="material-icons" *ngIf="Filter.Brand?.ID === b.ID" style="color: #4caf50; font-size: 14px; margin-left: 8px;">check</i>
                    </div>
                  </div>
                </div>
                <div *ngIf="!loadingBrands && Brands?.length === 0 && brandSearchTerm"
                     style="padding: 12px; text-align: center; color: #999; font-size: 11px;">
                  No brands found
                </div>
                <div *ngIf="Filter.Brand?.ID" style="padding: 8px; border-top: 1px solid #e0e0e0;">
                  <button (click)="clearBrandFilter()"
                          style="width: 100%; padding: 6px; background: #f44336; color: white;
                                 border: none; border-radius: 4px; cursor: pointer; font-size: 11px;">
                    Clear Filter
                  </button>
                </div>
              </div>
            </div>

            <!-- Supplier Filter Overlay -->
            <div class="custom-header-overlay filter-cell"
                 *ngIf="col.field === 'supplier'"
                 [style.width.px]="col.width"
                 [style.left.px]="col.left">
              <div class="filter-controls">
                <button *ngIf="Filter.Supplier?.ID" class="filter-clear-btn"
                        (click)="clearSupplierFilter(); $event.stopPropagation();">
                  <i class="material-icons">close</i>
                </button>
                <button class="filter-dropdown-btn" (click)="openSupplierPopup()">
                  <i class="material-icons">expand_more</i>
                </button>
              </div>

              <!-- Supplier Filter Popup -->
              <div class="SearchResultsAlternativesContainer grid-style-popup supplier-alternatives-popup"
                   *ngIf="showSupplierPopup"
                   style="position: absolute; top: 100%; left: 0; min-width: 300px; z-index: 10000;">
                <div style="padding: 8px; border-bottom: 1px solid #e0e0e0;">
                  <input type="text" class="supplier-popup-search-input" placeholder="Search supplier..."
                         [(ngModel)]="supplierSearchTerm" (ngModelChange)="searchSupplierUpdate.next($event)"
                         style="width: 100%; padding: 6px 10px; border: 1px solid #ddd; border-radius: 4px; font-size: 11px; outline: none; box-sizing: border-box;" />
                </div>
                <div *ngIf="loadingSuppliers" style="padding: 15px; text-align: center;">
                  <mat-spinner [diameter]="20"></mat-spinner>
                </div>
                <div *ngIf="!loadingSuppliers && Suppliers?.length > 0" style="max-height: 250px; overflow-y: auto;">
                  <div class="supplier-popup-item" *ngFor="let s of Suppliers" (click)="selectSupplierFilter(s)">
                    <div class="supplier-popup-column" style="flex: 1; padding: 8px 12px;">
                      {{ s?.Name }}
                      <i class="material-icons" *ngIf="Filter.Supplier?.ID === s.ID" style="color: #4caf50; font-size: 14px; margin-left: 8px;">check</i>
                    </div>
                  </div>
                </div>
                <div *ngIf="!loadingSuppliers && Suppliers?.length === 0 && supplierSearchTerm"
                     style="padding: 12px; text-align: center; color: #999; font-size: 11px;">
                  No suppliers found
                </div>
                <div *ngIf="Filter.Supplier?.ID" style="padding: 8px; border-top: 1px solid #e0e0e0;">
                  <button (click)="clearSupplierFilter()"
                          style="width: 100%; padding: 6px; background: #f44336; color: white;
                                 border: none; border-radius: 4px; cursor: pointer; font-size: 11px;">
                    Clear Filter
                  </button>
                </div>
              </div>
            </div>

            <!-- Partner Filter Overlay -->
            <div class="custom-header-overlay filter-cell"
                 *ngIf="col.field === 'partnerName'"
                 [style.width.px]="col.width"
                 [style.left.px]="col.left">
              <div class="filter-controls">
                <button *ngIf="Filter.Partner?.ID" class="filter-clear-btn"
                        (click)="clearPartnerFilter(); $event.stopPropagation();">
                  <i class="material-icons">close</i>
                </button>
                <button class="filter-dropdown-btn" (click)="openPartnerPopup()">
                  <i class="material-icons">expand_more</i>
                </button>
              </div>

              <!-- Partner Filter Popup -->
              <div class="SearchResultsAlternativesContainer grid-style-popup supplier-alternatives-popup"
                   *ngIf="showPartnerPopup"
                   style="position: absolute; top: 100%; left: 0; min-width: 300px; z-index: 10000;">
                <div style="padding: 8px; border-bottom: 1px solid #e0e0e0;">
                  <input type="text" class="supplier-popup-search-input" placeholder="Search partner..."
                         [(ngModel)]="partnerSearchTerm" (ngModelChange)="partnerPopupSearchUpdate.next($event)"
                         style="width: 100%; padding: 6px 10px; border: 1px solid #ddd; border-radius: 4px; font-size: 11px; outline: none; box-sizing: border-box;" />
                </div>
                <div *ngIf="loadingPartners" style="padding: 15px; text-align: center;">
                  <mat-spinner [diameter]="20"></mat-spinner>
                </div>
                <div *ngIf="!loadingPartners && Partners?.length > 0" style="max-height: 250px; overflow-y: auto;">
                  <div class="supplier-popup-item" *ngFor="let p of Partners" (click)="selectPartnerFilter(p)">
                    <div class="supplier-popup-column" style="flex: 1; padding: 8px 12px;">
                      {{ p?.Name }}
                      <i class="material-icons" *ngIf="Filter.Partner?.ID === p.ID" style="color: #4caf50; font-size: 14px; margin-left: 8px;">check</i>
                    </div>
                  </div>
                </div>
                <div *ngIf="!loadingPartners && Partners?.length === 0 && partnerSearchTerm"
                     style="padding: 12px; text-align: center; color: #999; font-size: 11px;">
                  No partners found
                </div>
                <div *ngIf="Filter.Partner?.ID" style="padding: 8px; border-top: 1px solid #e0e0e0;">
                  <button (click)="clearPartnerFilter()"
                          style="width: 100%; padding: 6px; background: #f44336; color: white;
                                 border: none; border-radius: 4px; cursor: pointer; font-size: 11px;">
                    Clear Filter
                  </button>
                </div>
              </div>
            </div>

            <!-- Progress Status Filter Overlay -->
            <div class="custom-header-overlay filter-cell"
                 *ngIf="col.field === 'progressStatus'"
                 [style.width.px]="col.width"
                 [style.left.px]="col.left">
              <div class="filter-controls">
                <button *ngIf="Filter.CartItemProgressStatus?.ID != null" class="filter-clear-btn"
                        (click)="clearProgressStatusFilter(); $event.stopPropagation();">
                  <i class="material-icons">close</i>
                </button>
                <button class="filter-dropdown-btn" (click)="openProgressStatusFilterPopup()">
                  <i class="material-icons">expand_more</i>
                </button>
              </div>

              <!-- Progress Status Filter Popup -->
              <div class="SearchResultsAlternativesContainer grid-style-popup supplier-alternatives-popup"
                   *ngIf="showProgressStatusFilterPopup"
                   style="position: absolute; top: 100%; left: 0; min-width: 150px; z-index: 10000;">
                <div *ngIf="MasterData?.PurchaseOrderStatuses?.length > 0" style="max-height: 250px; overflow-y: auto;">
                  <div class="supplier-popup-item" *ngFor="let s of MasterData?.PurchaseOrderStatuses"
                       (click)="selectProgressStatusGridFilter(s)"
                       [style.backgroundColor]="getProgressStatusBgColor(s.ID)">
                    <div class="supplier-popup-column" style="flex: 1; padding: 6px 10px; font-size: 11px;"
                         [style.color]="getProgressStatusTextColor(s.ID)">
                      {{ s?.Name }}
                      <i class="material-icons" *ngIf="Filter.CartItemProgressStatus?.ID === s.ID"
                         style="color: #4caf50; font-size: 14px; margin-left: 6px;">check</i>
                    </div>
                  </div>
                </div>
                <div *ngIf="Filter.CartItemProgressStatus?.ID != null" style="padding: 6px; border-top: 1px solid #e0e0e0;">
                  <button (click)="clearProgressStatusFilter()"
                          style="width: 100%; padding: 5px; background: #f44336; color: white;
                                 border: none; border-radius: 4px; cursor: pointer; font-size: 10px;">
                    Clear Filter
                  </button>
                </div>
              </div>
            </div>

          </ng-container>
        </ng-container>

        <ag-grid-angular
          class="ag-theme-alpine admin-grid"
          style="width: 100%; height: 600px;"
          [rowData]="ProductItems"
          [columnDefs]="productsColumnDefs"
          [defaultColDef]="productsDefaultColDef"
          [gridOptions]="productsGridOptions"
          (gridReady)="onProductsGridReady($event)"
          (contextmenu)="$event.preventDefault()">
        </ag-grid-angular>

        <!-- Brand Collateral Popup (matching original) -->
        <div class="BrandCollateralContainer" *ngIf="ShowProductsBrandCollateral == true" [ngStyle]="ProductsBrandPopupPosition">
          <div class="SearchResultsList" *ngIf="ProductsLoadingSideOffers === true" style="margin-top: 50px; margin-bottom: 50px; overflow: hidden;">
            <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
          </div>
          <div *ngIf="ProductsLoadingSideOffers != true;" class="SearchResultsList" style="overflow: hidden;">
            <div class="brand-collateral-item" *ngFor="let b of ProductsBrandCollateralList" (click)="selectProductsBrand(b);">
              <span>{{ b?.Name}}</span>
              <i class="material-icons" *ngIf="b.IsSelected == true;">check</i>
            </div>
          </div>
        </div>

        <!-- Name/Product Alternatives Popup (matching original with tabs) -->
        <div class="SearchResultsAlternativesContainer grid-style-popup animated fadeIn"
             *ngIf="ShowProductsETAAlternatives === true"
             [ngStyle]="ProductsSearchResultsPosition">

          <div class="SearchResultsHeader">
            <span>{{ 'OtherOffers' | translate }}</span>
            <div style="display:flex;align-items:center;gap:4px;">
              <button class="ChainHistoryBtn" (click)="loadChainHistory()" title="{{ 'ItemChainHistory' | translate }}">
                <i class="material-icons">link</i>
              </button>
              <button class="CloseBtn" (click)="ShowProductsETAAlternatives = false">×</button>
            </div>
          </div>

          <!-- Tabs -->
          <div class="GridModeTabsWrapper">
            <div class="GridModeTab" [ngClass]="{'SelectedGridModeTab': selectedProductsNamePopupTab === 1}" (click)="onProductsNamePopupTabChange(1)">
              <span>{{'OtherOffers' | translate}}</span>
            </div>
            <div class="GridModeTab" [ngClass]="{'SelectedGridModeTab': selectedProductsNamePopupTab === 2}" (click)="onProductsNamePopupTabChange(2)">
              <span>{{'SimilarProducts' | translate}}</span>
            </div>
          </div>

          <div class="SearchResultsList" *ngIf="ProductsLoadingSideOffers === true" style="margin-top: 50px; margin-bottom: 50px;">
            <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
          </div>

          <!-- Tab 1: Other Offers -->
          <div class="SearchResultsList" *ngIf="ProductsLoadingSideOffers !== true && selectedProductsNamePopupTab === 1">
            <div class="OfferRow header-row">
              <div class="GridCell indexx-column" style="font-style: italic;">#</div>
              <div class="GridCell brand-column" style="font-style: italic;">{{'Brand' | translate}}</div>
              <div class="GridCell partnumber-column" style="font-style: italic;">{{'ProductCode' | translate}}</div>
              <div class="GridCell name-column" style="font-style: italic;">{{'ProductName' | translate}}</div>
              <div class="GridCell qty-column" style="font-style: italic;">min.{{'Quantity' | translate}}</div>
              <div class="GridCell price-column" style="font-style: italic;">{{'SellPrice' | translate}}</div>
              <div class="GridCell total-column" style="font-style: italic;">{{'Total' | translate}}</div>
              <div class="GridCell eta-column" style="font-style: italic;">{{'ETA' | translate}}</div>
              <div class="GridCell supplier-column" style="font-style: italic;">Supplier</div>
              <div class="GridCell purchase-column" style="font-style: italic;">Purchase</div>
              <div class="GridCell hscode-column" style="font-style: italic;">{{'HSCode' | translate}}</div>
              <div class="GridCell coo-column" style="font-style: italic;">{{'COO' | translate}}</div>
              <div class="GridCell weight-column" style="font-style: italic;">{{'Weight' | translate}}</div>
              <div class="GridCell x-column" style="font-style: italic;"></div>
            </div>
            <div class="OfferRow"
                *ngFor="let result of ProductsSideOffers; index as i"
                (click)="selectProductsSideOffer(result)"
                [ngClass]="{ 'SelectedRow': result.IsSelected, 'GridValid': result.SelectedOffer?.IsStockOffer == true && result.SelectedOffer?.IsManufacturerStockOffer != true }">
              <div class="GridCell indexx-column">{{i + 1}}</div>
              <div class="GridCell brand-column">{{result.Product?.Brand?.Name}}</div>
              <div class="GridCell partnumber-column">{{result.Product?.PartNumber}}</div>
              <div class="GridCell name-column">
                <i class="material-icons SelectedGridRowName" *ngIf="result.IsSelected == true;">check</i>
                <span>{{result.Product?.Name}}</span>
                <span class="GridCellSpecialPriceSignal" *ngIf="result.SelectedOffer?.Configuration?.SpecialPriceList == true;">({{'SpecialPriceOffer' | translate}})</span>
              </div>
              <div class="GridCell qty-column">{{result.Quantity}}</div>
              <div class="GridCell price-column">{{result.Price?.UIUnitPrice}} {{result.SelectedOffer?.Currency?.Symbol}}</div>
              <div class="GridCell total-column">{{result.Price?.UIQtyPrice}} {{result.SelectedOffer?.Currency?.Symbol}}</div>
              <div class="GridCell eta-column">
                <span *ngIf="result.SelectedOffer?.LeadTime?.Units > 0">{{result.SelectedOffer.LeadTime.Units}} {{result.SelectedOffer.LeadTime.Type?.Name}}</span>
                <span *ngIf="!result.SelectedOffer?.LeadTime?.Units || result.SelectedOffer?.LeadTime?.Units == 0">------</span>
              </div>
              <div class="GridCell supplier-column">{{result.SelectedOffer?.Partner?.Name}}</div>
              <div class="GridCell purchase-column">{{result.SelectedOffer?.ListPrice}}</div>
              <div class="GridCell hscode-column">{{result.Product?.Stats?.HSCode}}</div>
              <div class="GridCell coo-column">{{result.Product?.Stats?.COO?.ShortName}}</div>
              <div class="GridCell weight-column">{{result.Product?.Stats?.Weight}}</div>
              <div class="GridCell x-column"></div>
            </div>
            <div class="NoAlternatives" *ngIf="ProductsSideOffers?.length === 0">
              No alternatives available
            </div>
          </div>

          <!-- Tab 2: Similar Products -->
          <div class="SearchResultsList" *ngIf="ProductsLoadingSideOffers !== true && selectedProductsNamePopupTab === 2">
            <div class="OfferRow header-row">
              <div class="GridCell indexx-column" style="font-style: italic;">#</div>
              <div class="GridCell brand-column" style="font-style: italic;">{{'Brand' | translate}}</div>
              <div class="GridCell partnumber-column" style="font-style: italic;">{{'ProductCode' | translate}}</div>
              <div class="GridCell name-column" style="font-style: italic;">{{'ProductName' | translate}}</div>
              <div class="GridCell qty-column" style="font-style: italic;">min.{{'Quantity' | translate}}</div>
              <div class="GridCell price-column" style="font-style: italic;">{{'SellPrice' | translate}}</div>
              <div class="GridCell total-column" style="font-style: italic;">{{'Total' | translate}}</div>
              <div class="GridCell eta-column" style="font-style: italic;">{{'ETA' | translate}}</div>
              <div class="GridCell supplier-column" style="font-style: italic;">Supplier</div>
              <div class="GridCell purchase-column" style="font-style: italic;">Purchase</div>
              <div class="GridCell hscode-column" style="font-style: italic;">{{'HSCode' | translate}}</div>
              <div class="GridCell coo-column" style="font-style: italic;">{{'COO' | translate}}</div>
              <div class="GridCell weight-column" style="font-style: italic;">{{'Weight' | translate}}</div>
              <div class="GridCell x-column" style="font-style: italic;"></div>
            </div>
            <div class="OfferRow"
                *ngFor="let result of ProductsSideOffers; index as i"
                (click)="selectProductsSideOffer(result)"
                [ngClass]="{ 'SelectedRow': result.IsSelected, 'GridValid': result.SelectedOffer?.IsStockOffer == true && result.SelectedOffer?.IsManufacturerStockOffer != true }">
              <div class="GridCell indexx-column">{{i + 1}}</div>
              <div class="GridCell brand-column">{{result.Product?.Brand?.Name}}</div>
              <div class="GridCell partnumber-column">{{result.Product?.PartNumber}}</div>
              <div class="GridCell name-column">
                <i class="material-icons SelectedGridRowName" *ngIf="result.IsSelected == true;">check</i>
                <span>{{result.Product?.Name}}</span>
                <span class="GridCellSpecialPriceSignal" *ngIf="result.SelectedOffer?.Configuration?.SpecialPriceList == true;">({{'SpecialPriceOffer' | translate}})</span>
              </div>
              <div class="GridCell qty-column">{{result.Quantity}}</div>
              <div class="GridCell price-column">{{result.Price?.UIUnitPrice}} {{result.SelectedOffer?.Currency?.Symbol}}</div>
              <div class="GridCell total-column">{{result.Price?.UIQtyPrice}} {{result.SelectedOffer?.Currency?.Symbol}}</div>
              <div class="GridCell eta-column">
                <span *ngIf="result.SelectedOffer?.LeadTime?.Units > 0">{{result.SelectedOffer.LeadTime.Units}} {{result.SelectedOffer.LeadTime.Type?.Name}}</span>
                <span *ngIf="!result.SelectedOffer?.LeadTime?.Units || result.SelectedOffer?.LeadTime?.Units == 0">------</span>
              </div>
              <div class="GridCell supplier-column">{{result.SelectedOffer?.Partner?.Name}}</div>
              <div class="GridCell purchase-column">{{result.SelectedOffer?.ListPrice}}</div>
              <div class="GridCell hscode-column">{{result.Product?.Stats?.HSCode}}</div>
              <div class="GridCell coo-column">{{result.Product?.Stats?.COO?.ShortName}}</div>
              <div class="GridCell weight-column">{{result.Product?.Stats?.Weight}}</div>
              <div class="GridCell x-column"></div>
            </div>
            <div class="NoAlternatives" *ngIf="ProductsSideOffers?.length === 0">
              No similar products available
            </div>
          </div>
        </div>

        <!-- ✅ Apple-style Chain History Centered Overlay -->
        <ng-container *ngIf="ShowChainHistory">
          <div class="AppleChainPanel-overlay" (click)="ShowChainHistory = false"></div>
          <div class="AppleChainPanel">
            <div class="AppleChainPanel-glass">
              <div class="AppleChainPanel-header">
                <div class="AppleChainPanel-headerLeft"><i class="material-icons AppleChainPanel-headerIcon">link</i><span>{{ 'ChainHistoryTitle' | translate }}</span></div>
                <button class="AppleChainPanel-closeBtn" (click)="ShowChainHistory = false"><i class="material-icons">close</i></button>
              </div>
              <div class="AppleChainPanel-body">
                <div *ngIf="ChainHistoryLoading" class="AppleChainPanel-loading"><mat-spinner [diameter]="24"></mat-spinner><span>{{ 'LoadingChainHistory' | translate }}</span></div>
                <div *ngIf="!ChainHistoryLoading && ChainHistoryOrderChain?.length === 0" class="AppleChainPanel-empty"><i class="material-icons">link_off</i><span>{{ 'NoChainHistory' | translate }}</span></div>
                <div *ngIf="!ChainHistoryLoading && ChainHistoryOrderChain?.length > 0" class="AppleChainTimeline">
                  <ng-container *ngFor="let step of ChainHistoryOrderChain; let i = index; let last = last">
                    <div class="AppleChainStep" *ngIf="i === 0 && step.OldOrderType">
                      <div class="AppleChainStep-pill" [style.background]="getOrderTypeColor(step.OldOrderType.ID)"><i class="material-icons">{{getOrderTypeIcon(step.OldOrderType.ID)}}</i></div>
                      <div class="AppleChainStep-card">
                        <span class="AppleChainStep-type" [style.color]="getOrderTypeColor(step.OldOrderType.ID)">{{getOrderTypeName(step.OldOrderType.ID)}}</span>
                        <div class="AppleChainStep-card-row"><span class="AppleChainStep-id">#{{step.OldOrderDBID}}</span><span class="AppleChainStep-ref" *ngIf="step.OldOrderReferenceNumber">{{step.OldOrderReferenceNumber}}</span></div>
                        <div class="AppleChainStep-card-row" *ngIf="step.OldPartnerName"><span class="AppleChainStep-detail"><i class="material-icons">business</i>{{ 'ChainPartner' | translate }}: {{step.OldPartnerName}}</span></div>
                        <div class="AppleChainStep-card-row" *ngIf="step.OldDebatorPO"><span class="AppleChainStep-detail"><i class="material-icons">receipt</i>{{ 'ChainDebatorPO' | translate }}: {{step.OldDebatorPO}}</span></div>
                        <div class="AppleChainStep-card-row" *ngIf="step.OldEventRegister"><span class="AppleChainStep-detail"><i class="material-icons">event</i>{{ 'ChainCreated' | translate }}: {{step.OldEventRegister | date:'dd MMM yyyy HH:mm'}}</span></div>
                        <div class="AppleChainStep-card-row" *ngIf="step.OldTotalNoVAT"><span class="AppleChainStep-detail"><i class="material-icons">payments</i>{{ 'ChainTotal' | translate }}: {{step.OldTotalNoVAT | number:'1.2-4'}}</span></div>
                        <div class="AppleChainStep-product" *ngIf="getChainItemQuantities(step.DBID)?.OldBrandName || getChainItemQuantities(step.DBID)?.OldProductName"><span class="AppleChainStep-brand" *ngIf="getChainItemQuantities(step.DBID)?.OldBrandName">{{getChainItemQuantities(step.DBID).OldBrandName}}</span><span class="AppleChainStep-productName" *ngIf="getChainItemQuantities(step.DBID)?.OldProductName">{{getChainItemQuantities(step.DBID).OldProductName}}</span><span class="AppleChainStep-partNumber" *ngIf="getChainItemQuantities(step.DBID)?.OldPartNumber">{{getChainItemQuantities(step.DBID).OldPartNumber}}</span></div>
                        <div class="AppleChainStep-card-row" *ngIf="getChainItemQuantities(step.DBID)?.OldOrderItemQuantity"><span class="AppleChainStep-qty">{{ 'Quantity' | translate }}: {{getChainItemQuantities(step.DBID).OldOrderItemQuantity}}</span></div>
                        <div class="AppleChainStep-card-row" *ngIf="getChainItemQuantities(step.DBID)?.OldUnitPrice || getChainItemQuantities(step.DBID)?.OldSellPrice"><span class="AppleChainStep-detail" *ngIf="getChainItemQuantities(step.DBID)?.OldUnitPrice"><i class="material-icons">sell</i>{{ 'ChainUnitPrice' | translate }}: {{getChainItemQuantities(step.DBID).OldUnitPrice | number:'1.2-4'}}</span><span class="AppleChainStep-detail" *ngIf="getChainItemQuantities(step.DBID)?.OldSellPrice" style="margin-left:8px"><i class="material-icons">price_check</i>{{ 'ChainSellPrice' | translate }}: {{getChainItemQuantities(step.DBID).OldSellPrice | number:'1.2-4'}}</span></div>
                      </div>
                    </div>
                    <div class="AppleChainStep-connector" *ngIf="i === 0 && step.OldOrderType"><div class="AppleChainStep-line"></div><i class="material-icons">south</i></div>
                    <div class="AppleChainStep">
                      <div class="AppleChainStep-pill" [style.background]="getOrderTypeColor(step.NewOrderType.ID)"><i class="material-icons">{{getOrderTypeIcon(step.NewOrderType.ID)}}</i></div>
                      <div class="AppleChainStep-card">
                        <span class="AppleChainStep-type" [style.color]="getOrderTypeColor(step.NewOrderType.ID)">{{getOrderTypeName(step.NewOrderType.ID)}}</span>
                        <div class="AppleChainStep-card-row"><span class="AppleChainStep-id">#{{step.NewOrderDBID}}</span><span class="AppleChainStep-ref" *ngIf="step.NewOrderReferenceNumber">{{step.NewOrderReferenceNumber}}</span></div>
                        <div class="AppleChainStep-card-row" *ngIf="step.NewPartnerName"><span class="AppleChainStep-detail"><i class="material-icons">business</i>{{ 'ChainPartner' | translate }}: {{step.NewPartnerName}}</span></div>
                        <div class="AppleChainStep-card-row" *ngIf="step.NewDebatorPO"><span class="AppleChainStep-detail"><i class="material-icons">receipt</i>{{ 'ChainDebatorPO' | translate }}: {{step.NewDebatorPO}}</span></div>
                        <div class="AppleChainStep-card-row" *ngIf="step.NewEventRegister"><span class="AppleChainStep-detail"><i class="material-icons">event</i>{{ 'ChainCreated' | translate }}: {{step.NewEventRegister | date:'dd MMM yyyy HH:mm'}}</span></div>
                        <div class="AppleChainStep-card-row" *ngIf="step.NewTotalNoVAT"><span class="AppleChainStep-detail"><i class="material-icons">payments</i>{{ 'ChainTotal' | translate }}: {{step.NewTotalNoVAT | number:'1.2-4'}}</span></div>
                        <div class="AppleChainStep-product" *ngIf="getChainItemQuantities(step.DBID)?.NewBrandName || getChainItemQuantities(step.DBID)?.NewProductName"><span class="AppleChainStep-brand" *ngIf="getChainItemQuantities(step.DBID)?.NewBrandName">{{getChainItemQuantities(step.DBID).NewBrandName}}</span><span class="AppleChainStep-productName" *ngIf="getChainItemQuantities(step.DBID)?.NewProductName">{{getChainItemQuantities(step.DBID).NewProductName}}</span><span class="AppleChainStep-partNumber" *ngIf="getChainItemQuantities(step.DBID)?.NewPartNumber">{{getChainItemQuantities(step.DBID).NewPartNumber}}</span></div>
                        <div class="AppleChainStep-card-row" *ngIf="getChainItemQuantities(step.DBID)?.NewOrderItemQuantity"><span class="AppleChainStep-qty">{{ 'Quantity' | translate }}: {{getChainItemQuantities(step.DBID).NewOrderItemQuantity}}</span></div>
                        <div class="AppleChainStep-card-row" *ngIf="getChainItemQuantities(step.DBID)?.NewUnitPrice || getChainItemQuantities(step.DBID)?.NewSellPrice"><span class="AppleChainStep-detail" *ngIf="getChainItemQuantities(step.DBID)?.NewUnitPrice"><i class="material-icons">sell</i>{{ 'ChainUnitPrice' | translate }}: {{getChainItemQuantities(step.DBID).NewUnitPrice | number:'1.2-4'}}</span><span class="AppleChainStep-detail" *ngIf="getChainItemQuantities(step.DBID)?.NewSellPrice" style="margin-left:8px"><i class="material-icons">price_check</i>{{ 'ChainSellPrice' | translate }}: {{getChainItemQuantities(step.DBID).NewSellPrice | number:'1.2-4'}}</span></div>
                        <span class="AppleChainStep-date">{{step.ConnectionEventRegister | date:'dd MMM yyyy HH:mm'}}</span>
                      </div>
                    </div>
                    <div class="AppleChainStep-connector" *ngIf="!last"><div class="AppleChainStep-line"></div><i class="material-icons">south</i></div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </ng-container>


        <!-- Supplier Alternatives Popup (matching original) -->
        <div class="SearchResultsAlternativesContainer grid-style-popup supplier-alternatives-popup animated fadeIn"
            *ngIf="ShowProductsSupplierAlternatives === true && ProductsLoadingSideOffers !== true && (ProductsSideOffers?.length > 0 || ProductsSupplierPopupSearchTerm?.length > 0)"
            [ngStyle]="ProductsSupplierPopupPosition">

          <!-- Search Textbox -->
          <div style="padding: 8px; border-bottom: 1px solid #e0e0e0;">
            <input
              type="text"
              class="supplier-popup-search-input"
              placeholder="Search supplier..."
              [(ngModel)]="ProductsSupplierPopupSearchTerm"
              (ngModelChange)="SearchProductsSupplierPopup()"
              style="width: 100%; padding: 6px 10px; border: 1px solid #ddd; border-radius: 4px; font-size: 11px; outline: none; box-sizing: border-box;"
            />
          </div>

          <!-- Show search results when searching -->
          <div *ngIf="ProductsSupplierPopupSearchTerm?.length > 0 && ProductsSupplierPopupSearchResults?.length > 0">
            <div class="supplier-popup-item" *ngFor="let partner of ProductsSupplierPopupSearchResults" (click)="SelectProductsPartnerFromSearch(partner)">
              <div class="supplier-popup-column" style="flex: 1; padding: 8px 12px;">
                {{ partner?.Name }}
              </div>
            </div>
          </div>

          <!-- Show original side offers when NOT searching -->
          <div *ngIf="!ProductsSupplierPopupSearchTerm || ProductsSupplierPopupSearchTerm?.length === 0">
            <div class="supplier-popup-item" *ngFor="let cartItem of ProductsSideOffers" (click)="selectProductsSideOffer(cartItem)">
              <div class="supplier-popup-column supplier-name-column">
                <span *ngIf="cartItem?.SelectedOffer?.MOQ > 0">[{{ cartItem?.SelectedOffer?.MOQ }}] </span>{{ cartItem?.SelectedOffer?.Partner?.Name || 'N/A' }}
              </div>
              <div class="supplier-popup-column purchase-info-column">
                {{ cartItem?.SelectedOffer?.ListPrice || 'N/A' }} {{ cartItem?.SelectedOffer?.Currency?.Symbol || 'N/A' }}
              </div>
              <div class="supplier-popup-column stock-column">
                <span *ngIf="cartItem?.SelectedOffer?.StockQuantity > 0">STOCK</span>
              </div>
              <div class="supplier-popup-column leadtime-column">
                <span *ngIf="cartItem?.SelectedOffer?.LeadTime?.Units > 0">
                  {{ cartItem.SelectedOffer.LeadTime.Units }} {{ cartItem.SelectedOffer.LeadTime.Type?.Name || '' }}
                </span>
                <span *ngIf="!cartItem?.SelectedOffer?.LeadTime?.Units || cartItem?.SelectedOffer?.LeadTime?.Units <= 0">
                  ------
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Loading spinner for supplier popup -->
        <div class="SearchResultsAlternativesContainer grid-style-popup supplier-alternatives-popup animated fadeIn"
            *ngIf="ShowProductsSupplierAlternatives === true && ProductsLoadingSideOffers === true"
            [ngStyle]="ProductsSupplierPopupPosition"
            style="min-height: 100px; display: flex; align-items: center; justify-content: center;">
          <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
        </div>

        <!-- ✅ Purchase Currency Dropdown Popup -->
        <div class="BrandCollateralContainer" *ngIf="showPurchaseCurrencyDropdown" [ngStyle]="purchaseCurrencyDropdownPosition" style="max-height: 200px; overflow-y: auto;">
          <div class="SearchResultsList" style="overflow: hidden;">
            <div *ngIf="parent.masterData?.Currencies?.length > 0">
              <div class="brand-collateral-item"
                   *ngFor="let currency of parent.masterData.Currencies"
                   (click)="selectPurchaseCurrency(currency)">
                <div style="display: flex; align-items: center; gap: 8px;">
                  <span style="font-weight: 600; min-width: 30px;">{{ currency.Symbol }}</span>
                  <span style="color: #666; font-size: 12px;">{{ currency.Name }}</span>
                </div>
              </div>
            </div>
            <div *ngIf="!parent.masterData?.Currencies?.length" style="text-align: center; padding: 20px; color: #999;">
              No currencies available
            </div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div class="EmptyState" *ngIf="ProductItems?.length == 0">
        <i class="material-icons">inventory_2</i>
        <span>{{ 'NoProductsFound' | translate }}</span>
      </div>
    </div>
  </div>
</div>

<!-- Delete Cart Item Confirmation Popup -->
<div class="ConvertToOrderConfirmationOverlay" *ngIf="ShowDeleteCartItemConfirmation" (click)="ShowDeleteCartItemConfirmation = false; IsMultiDelete = false;"></div>
<div class="ConvertToOrderConfirmationPopup animated fadeInDown" *ngIf="ShowDeleteCartItemConfirmation">
  <div class="ConvertPopupHeader">
    <div class="ConvertPopupIconWrapper" style="background: #d32f2f;">
      <i class="material-icons">delete</i>
    </div>
    <div class="ConvertPopupHeaderText">
      <span class="ConvertPopupTitle" *ngIf="!IsMultiDelete">{{ 'DeleteCartItem' | translate }}</span>
      <span class="ConvertPopupTitle" *ngIf="IsMultiDelete">{{ 'DeleteCartItems' | translate }}</span>
    </div>
    <i class="material-icons ConvertPopupClose" (click)="ShowDeleteCartItemConfirmation = false; IsMultiDelete = false;">close</i>
  </div>
  <div class="ConvertPopupBody">
    <p class="ConvertPopupMessage" *ngIf="!IsMultiDelete">{{ 'DeleteCartItemConfirmation' | translate }}</p>
    <p class="ConvertPopupMessage" *ngIf="IsMultiDelete">{{ 'DeleteCartItemsConfirmation' | translate }}</p>
  </div>
  <div class="ConvertPopupFooter">
    <div class="GridCommandButton" [class.disabled]="this.parent.loading" (click)="ShowDeleteCartItemConfirmation = false; IsMultiDelete = false;">
      <i class="material-icons">close</i>
      <span>{{ 'No' | translate }}</span>
    </div>
    <div class="GridCommandButton GridCommandButtonRed" [class.disabled]="this.parent.loading" (click)="ConfirmDeleteCartItem();">
      <i class="material-icons" *ngIf="!this.parent.loading">check</i>
      <span *ngIf="!this.parent.loading">{{ 'Yes' | translate }}</span>
      <mat-spinner *ngIf="this.parent.loading" diameter="18"></mat-spinner>
    </div>
  </div>
</div>

<!-- Change Partner Confirmation Popup -->
<div class="ConvertToOrderConfirmationOverlay" *ngIf="ShowChangePartnerConfirmation" (click)="cancelChangePartner()"></div>
<div class="ConvertToOrderConfirmationPopup animated fadeInDown" *ngIf="ShowChangePartnerConfirmation">
  <div class="ConvertPopupHeader">
    <div class="ConvertPopupIconWrapper" style="background: #1976d2;">
      <i class="material-icons">swap_horiz</i>
    </div>
    <div class="ConvertPopupHeaderText">
      <span class="ConvertPopupTitle">{{ 'ChangePartner' | translate }}</span>
    </div>
    <i class="material-icons ConvertPopupClose" (click)="cancelChangePartner()">close</i>
  </div>
  <div class="ConvertPopupBody">
    <p class="ConvertPopupMessage">{{ 'ChangePartnerConfirmation' | translate }}</p>
    <p class="ConvertPopupMessage" *ngIf="PendingPartnerChange?.Name"><strong>{{ PendingPartnerChange.Name }}</strong></p>
  </div>
  <div class="ConvertPopupFooter">
    <div class="GridCommandButton" [class.disabled]="this.parent.loading" (click)="cancelChangePartner()">
      <i class="material-icons">close</i>
      <span>{{ 'No' | translate }}</span>
    </div>
    <div class="GridCommandButton GridCommandButtonGreen" [class.disabled]="this.parent.loading" (click)="confirmChangePartner()">
      <i class="material-icons" *ngIf="!this.parent.loading">check</i>
      <span *ngIf="!this.parent.loading">{{ 'Yes' | translate }}</span>
      <mat-spinner *ngIf="this.parent.loading" diameter="18"></mat-spinner>
    </div>
  </div>
</div>

<!-- Progress Status Right-Click Popup -->
<div class="progress-status-cell-popup" *ngIf="showProgressStatusCellPopup"
     [style.top]="progressStatusPopupPosition.top"
     [style.left]="progressStatusPopupPosition.left">
  <div class="progress-status-cell-popup-overlay" (click)="closeProgressStatusCellPopup()"></div>
  <div class="progress-status-cell-popup-content">
    <div class="progress-status-cell-popup-item"
         *ngFor="let status of MasterData?.PurchaseOrderStatuses"
         (click)="selectProgressStatusForCartItem(status)"
         [class.selected]="progressStatusPopupCartItem?.ProgressStatus?.ID === status.ID">
      <span>{{ status.Name }}</span>
      <i class="material-icons" *ngIf="progressStatusPopupCartItem?.ProgressStatus?.ID === status.ID"
         [style.color]="getProgressStatusTextColor(status.ID)">check</i>
    </div>
  </div>
</div>

<!-- DeliveryPreference Right-Click Popup -->
<div class="progress-status-cell-popup" *ngIf="showDeliveryPreferencePopup"
     [style.top]="deliveryPreferencePopupPosition.top"
     [style.left]="deliveryPreferencePopupPosition.left">
  <div class="progress-status-cell-popup-overlay" (click)="closeDeliveryPreferencePopup()"></div>
  <div class="progress-status-cell-popup-content">
    <div class="progress-status-cell-popup-item"
         *ngFor="let dp of deliveryPreferenceOptions"
         (click)="selectDeliveryPreferenceForCartItem(dp)"
         [class.selected]="deliveryPreferencePopupCartItem?.DeliveryPreference?.ID === dp.ID">
      <span>{{ dp.Name }}</span>
      <i class="material-icons" *ngIf="deliveryPreferencePopupCartItem?.DeliveryPreference?.ID === dp.ID">check</i>
    </div>
  </div>
</div>

<!-- ConsolidationType Right-Click Popup -->
<div class="progress-status-cell-popup" *ngIf="showConsolidationTypePopup"
     [style.top]="consolidationTypePopupPosition.top"
     [style.left]="consolidationTypePopupPosition.left">
  <div class="progress-status-cell-popup-overlay" (click)="closeConsolidationTypePopup()"></div>
  <div class="progress-status-cell-popup-content">
    <div class="progress-status-cell-popup-item"
         *ngFor="let ct of consolidationTypeOptions"
         (click)="selectConsolidationTypeForCartItem(ct)"
         [class.selected]="consolidationTypePopupCartItem?.ConsolidationType?.ID === ct.ID">
      <span>{{ ct.Name }}</span>
      <i class="material-icons" *ngIf="consolidationTypePopupCartItem?.ConsolidationType?.ID === ct.ID">check</i>
    </div>
  </div>
</div>